// product grid/list
function listgridJavascript() {
Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', function(event) {
        Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
        this.classList.add('active');
        if(this.classList.contains('listv')){
            document.getElementById('product-grid').classList.add('product-list');
            document.getElementById('product-grid').classList.remove('product-grid');
            document.getElementById('product-grid').classList.remove('product-gallery');
            // Remove 'active' class from gridv on mobile
              if (window.innerWidth < 992) { 
                document.querySelector(".gridv").classList.remove('active_mobile'); 
              }  
        }else if(this.classList.contains('gridv')){
            document.getElementById('product-grid').classList.add('product-grid');
            document.getElementById('product-grid').classList.remove('product-list');
            document.getElementById('product-grid').classList.remove('product-gallery');
        }else if(this.classList.contains('galleryv')){
            document.getElementById('product-grid').classList.add('product-gallery');
            document.getElementById('product-grid').classList.remove('product-list');
            document.getElementById('product-grid').classList.remove('product-grid');
        }
    });
});
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();


// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// timer
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date').replaceAll('-','/')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}
// Free shipping message customization for frozen items 
const tagToCheck = "Coldcart-Frozen";
const CUSTOMER_GROUPS = {
        "b2b-direct": [ // CUSTOMER GROUP B2B DIRECT
            { tag: "coldcart-frozen", moq: 150 },
            { tag: "coldcart-dry", moq: 150 },
        ],
        "psp-terms": [ // CUSTOMER GROUP PSP Terms
            { tag: "coldcart-frozen", moq: 150 },
            { tag: "coldcart-dry", moq: 150 },
        ],
        "psp-cc": [ // CUSTOMER GROUP PSP CC
            { tag: "coldcart-frozen", moq: 150 },
            { tag: "coldcart-dry", moq: 150 },
        ],
        "iso-15-off": [ // CUSTOMER GROUP ISO 15% OFF
            { tag: "coldcart-frozen", moq: 150 },
            { tag: "coldcart-dry", moq: 150 },
        ],
         "b2b-pet-supplies-plus": [ 
            { tag: "coldcart-frozen", moq: 0 },
            { tag: "coldcart-dry", moq: 0 },
        ]
    };
async function checkCartTagAndToggle2() {       
    document.querySelectorAll('.wbship').forEach(el => el.style.display = 'none');

  try {
    const cart = await fetch('/cart.js').then(res => res.json());

    const hasTag = await Promise.all(cart.items.map(async item => {
      const product = await fetch(`/products/${item.handle}.js`).then(r => r.json());

      let tags = [];
      if (Array.isArray(product.tags)) {
        tags = product.tags.map(t => t.trim());
      } else if (typeof product.tags === "string") {
        tags = product.tags.split(',').map(t => t.trim());
      }

      return tags.includes(tagToCheck);
    }));

    document.querySelectorAll('.wbship').forEach(el => {
      el.style.display = hasTag.includes(true) ? 'none' : '';
    });
  } catch (err) {
    console.error('Error checking cart:', err);
  }
}
function publishFrozenCartState(hasFrozen, hasDry, frozenProductsLength = 0, ready = true) {
  const length = Number.isFinite(frozenProductsLength)
    ? Math.max(0, frozenProductsLength)
    : hasFrozen
      ? 1
      : 0;

  const payload = {
    ready,
    hasFrozen: !!hasFrozen,
    hasDry: !!hasDry,
    frozenProductsLength: length,
    updatedAt: Date.now(),
  };

  window.__geoFrozenCartState = payload;
  window.__geoFrozenCartHasFrozenItem = !!hasFrozen;
  window.__geoFrozenProductsLength = payload.frozenProductsLength;
  window.dispatchEvent(new CustomEvent("mmq:frozen-cart-status", { detail: payload }));
  return payload;
}
async function checkCartTagAndToggle() {
  const FROZEN_TAG = "Coldcart-Frozen";
  const DRY_TAG = "Coldcart-Dry";
  const FROZEN_THRESHOLD = window.shippingThresholds?.frozen || 99;
  const DRY_THRESHOLD = window.shippingThresholds?.dry || 45;
  const freeShippingMessage = `
                  
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.6482 14.6719L5.32614 6.34983C4.98449 6.00817 4.43055 6.00817 4.08889 6.34983C3.74724 6.69148 3.74724 7.24542 4.08889 7.58708L12.411 15.9092C12.7526 16.2508 13.3066 16.2508 13.6482 15.9092C13.9899 15.5675 13.9899 15.0136 13.6482 14.6719Z" fill="#FFD54F"></path>
    <path d="M12.1316 15.6324L11.0874 16.0072L9.51766 16.5729L7.22428 17.4002L5.65685 17.9635L2.00023 19.2799C1.20396 19.5666 0.433817 18.7962 0.720731 18L1.67585 15.3496L2.13782 14.0579L2.81664 12.1723L3.28097 10.883L4.36757 7.86841L12.1316 15.6324Z" fill="#FCB316"></path>
    <path d="M11.0874 16.0072L9.51767 16.5729L2.81665 12.1723L3.28098 10.8831L11.0874 16.0072Z" fill="#E53A35"></path>
    <path d="M7.22433 17.4001L5.6569 17.9635L1.6759 15.3495L2.13787 14.0579L7.22433 17.4001Z" fill="#3D82C4"></path>
    <path d="M7.27539 2.16631e-06C7.62676 2.85282e-06 7.93369 0.241422 8.00478 0.585519C8.49883 2.97675 8.50809 5.26911 7.23717 7.30039C7.04286 7.61095 6.61255 7.63851 6.3535 7.37947V7.37947C6.17947 7.20544 6.12952 6.94385 6.21605 6.71345C6.9246 4.82686 7.02411 2.93987 6.51418 1.05246C6.37511 0.537741 6.74222 1.12455e-06 7.27539 2.16631e-06V2.16631e-06Z" fill="#7CB342"></path>
    <path d="M10.4401 7.83434C10.1387 8.04574 9.72291 7.97273 9.51151 7.67127V7.67127C9.30008 7.36977 9.37314 6.95395 9.67468 6.74257L9.76701 6.67785C10.0847 6.45515 10.1902 6.03271 10.0146 5.68677L9.92358 5.50748C9.62476 4.91959 9.80672 4.19043 10.3471 3.81185V3.81185C10.7577 3.52417 10.8953 2.97703 10.6677 2.53027V2.53027C10.3682 1.94173 10.5502 1.21224 11.0909 0.833333L11.7357 0.382176C12.0374 0.171106 12.4531 0.244562 12.6642 0.546244V0.546244C12.8752 0.84791 12.8018 1.26355 12.5001 1.47463L12.4095 1.53809C12.092 1.76024 11.9866 2.18227 12.1624 2.52759L12.2524 2.70442C12.5522 3.29264 12.3702 4.02213 11.8295 4.40104V4.40104C11.4179 4.68936 11.2819 5.23786 11.5095 5.68587V5.68587C11.8083 6.27343 11.6264 7.00227 11.0863 7.38118L10.4401 7.83434Z" fill="#3D82C4"></path>
    <path d="M20 12.7246C20 12.3732 19.7586 12.0663 19.4145 11.9952C17.0233 11.5012 14.7309 11.4919 12.6996 12.7628C12.3891 12.9571 12.3615 13.3875 12.6205 13.6465V13.6465C12.7946 13.8205 13.0562 13.8705 13.2866 13.7839C15.1731 13.0754 17.0601 12.9759 18.9475 13.4858C19.4623 13.6249 20 13.2578 20 12.7246V12.7246Z" fill="#7CB342"></path>
    <path d="M12.1656 9.56002C11.9542 9.86149 12.0272 10.2772 12.3287 10.4887V10.4887C12.6302 10.7001 13.046 10.627 13.2574 10.3255L13.3221 10.2331C13.5448 9.91546 13.9672 9.80992 14.3132 9.98555L14.4925 10.0766C15.0804 10.3754 15.8095 10.1934 16.1881 9.65307V9.65307C16.4758 9.24243 17.0229 9.10486 17.4697 9.33244V9.33244C18.0582 9.63192 18.7877 9.44995 19.1666 8.90926L19.6178 8.26442C19.8288 7.96274 19.7554 7.54707 19.4537 7.336V7.336C19.152 7.12495 18.7364 7.19838 18.5253 7.50003L18.4619 7.59071C18.2397 7.90818 17.8177 8.01357 17.4724 7.83781L17.2955 7.7478C16.7073 7.448 15.9778 7.62996 15.5989 8.17065V8.17065C15.3106 8.58223 14.7621 8.71828 14.3141 8.49064V8.49064C13.7265 8.19181 12.9977 8.37378 12.6188 8.91382L12.1656 9.56002Z" fill="#3D82C4"></path>
    <path d="M18.5104 1.48958C19.1594 2.13858 18.8447 3.28454 18.025 3.69745C17.109 4.1589 16.2234 4.79531 15.3705 5.62034C15.0927 5.88912 14.6483 5.89835 14.375 5.625V5.625C14.1017 5.35165 14.1109 4.90731 14.3797 4.62947C15.2047 3.77663 15.8411 2.89101 16.3025 1.97498C16.7155 1.15529 17.8614 0.84059 18.5104 1.48958V1.48958Z" fill="#E53A35"></path>
    </svg>
                    <div class="wbshipinner">
                      
                        Congratulations ! You qualify for
                      
                      <b>&nbsp;FREE SHIPPING!</b>
                      <span><svg class="icon icon-truck" viewBox="0 0 491.1 491.1">
<path transform="translate(0 -540.36)" d="M401.5,863.31c-12,0-23.4,4.7-32,13.2c-8.6,8.6-13.4,19.8-13.4,31.8s4.7,23.2,13.4,31.8
    c8.7,8.5,20,13.2,32,13.2c24.6,0,44.6-20.2,44.6-45S426.1,863.31,401.5,863.31z M401.5,933.31c-13.8,0-25.4-11.4-25.4-25
    s11.6-25,25.4-25c13.6,0,24.6,11.2,24.6,25S415.1,933.31,401.5,933.31z M413.1,713.41c-1.8-1.7-4.2-2.6-6.7-2.6h-51.3
    c-5.5,0-10,4.5-10,10v82c0,5.5,4.5,10,10,10h81.4c5.5,0,10-4.5,10-10v-54.9c0-2.8-1.2-5.5-3.3-7.4L413.1,713.41z M426.5,792.81
    h-61.4v-62.1h37.4l24,21.6V792.81z M157.3,863.31c-12,0-23.4,4.7-32,13.2c-8.6,8.6-13.4,19.8-13.4,31.8s4.7,23.2,13.4,31.8
    c8.7,8.5,20,13.2,32,13.2c24.6,0,44.6-20.2,44.6-45S181.9,863.31,157.3,863.31z M157.3,933.31c-13.8,0-25.4-11.4-25.4-25
    s11.6-25,25.4-25c13.6,0,24.6,11.2,24.6,25S170.9,933.31,157.3,933.31z M90.6,875.61H70.5v-26.6c0-5.5-4.5-10-10-10s-10,4.5-10,10
    v36.6c0,5.5,4.5,10,10,10h30.1c5.5,0,10-4.5,10-10S96.1,875.61,90.6,875.61z M141.3,821.11c0-5.5-4.5-10-10-10H10
    c-5.5,0-10,4.5-10,10s4.5,10,10,10h121.3C136.8,831.11,141.3,826.71,141.3,821.11z M30.3,785.01l121.3,0.7c5.5,0,10-4.4,10.1-9.9
    c0.1-5.6-4.4-10.1-9.9-10.1l-121.3-0.7c-0.1,0-0.1,0-0.1,0c-5.5,0-10,4.4-10,9.9C20.3,780.51,24.8,785.01,30.3,785.01z M50.7,739.61
    H172c5.5,0,10-4.5,10-10s-4.5-10-10-10H50.7c-5.5,0-10,4.5-10,10S45.2,739.61,50.7,739.61z M487.4,726.11L487.4,726.11l-71.6-59.3
    c-1.8-1.5-4-2.3-6.4-2.3h-84.2v-36c0-5.5-4.5-10-10-10H60.5c-5.5,0-10,4.5-10,10v73.2c0,5.5,4.5,10,10,10s10-4.5,10-10v-63.2h234.8
    v237.1h-82c-5.5,0-10,4.5-10,10s4.5,10,10,10h122.1c5.5,0,10-4.5,10-10s-4.5-10-10-10h-20.1v-191.1h80.6l65.2,54l-0.7,136.9H460
    c-5.5,0-10,4.5-10,10s4.5,10,10,10h20.3c5.5,0,10-4.4,10-9.9l0.8-151.6C491,730.91,489.7,728.01,487.4,726.11z"></path>
</svg>
</span></div>`;
  try {
    const cart = await fetch("/cart.js").then((res) => res.json());

    // Categorize items and calculate totals
    let frozenTotal = 0;
    let dryTotal = 0;
    let hasFrozen = false;
    let hasDry = false;

    await Promise.all(
      cart.items.map(async (item) => {
        const product = await fetch(`/products/${item.handle}.js`).then((r) =>
          r.json()
        );

        let tags = [];
        if (Array.isArray(product.tags)) {
          tags = product.tags.map((t) => t.trim());
        } else if (typeof product.tags === "string") {
          tags = product.tags.split(",").map((t) => t.trim());
        }

        //const itemTotal = (item.price * item.quantity) / 100; // Convert cents to dollars
      const itemTotal = (item.final_line_price || item.line_price) / 100; // Convert cents to dollars

        if (tags.includes(FROZEN_TAG)) {
          frozenTotal += itemTotal;
          hasFrozen = true;
        } else if (tags.includes(DRY_TAG)) {
          dryTotal += itemTotal;
          hasDry = true;
        }
      })
    );

    // Update UI based on cart composition
    document.querySelectorAll(".wbship").forEach((el) => {
      const amountEl = el.querySelector("b");
      const progressBar = el.querySelector(".determinate");
      const messageEl = el.querySelector(".wbship_wrapper") || el;
       el.style.display = 'flex';
      el.style.alignItems = 'center';
      el.style.gap = '5px';
      if (hasFrozen && hasDry) {
        // Mixed cart - both thresholds must be met
        const frozenRemaining = Math.max(0, FROZEN_THRESHOLD - frozenTotal);
        const dryRemaining = Math.max(0, DRY_THRESHOLD - dryTotal);

        if (frozenRemaining === 0 && dryRemaining === 0) {
          // Both thresholds met
          messageEl.innerHTML = freeShippingMessage;
          progressBar.style.width = "100%";
        } else {
          // Show what's needed
          const needed = [];
          if (frozenRemaining > 0)
            needed.push(`$${frozenRemaining.toFixed(2)} more in frozen items`);
          if (dryRemaining > 0)
            needed.push(`$${dryRemaining.toFixed(2)} more in dry items`);

          messageEl.innerHTML = `Spend ${needed.join(
            " and "
          )} for free shipping!`;

          // Calculate overall progress (average of both)
          const frozenProgress = (frozenTotal / FROZEN_THRESHOLD) * 100;
          const dryProgress = (dryTotal / DRY_THRESHOLD) * 100;
          const avgProgress = Math.min(100, (frozenProgress + dryProgress) / 2);
          progressBar.style.width = `${avgProgress}%`;
        }
      } else if (hasFrozen) {
        // Only frozen items
        const remaining = Math.max(0, FROZEN_THRESHOLD - frozenTotal);
        if (remaining === 0) {
          messageEl.innerHTML = freeShippingMessage;
          progressBar.style.width = "100%";
        } else {
         // amountEl.textContent = `$${remaining.toFixed(2)}`;
         messageEl.innerHTML = `Spend $${remaining.toFixed(2)} more to get free shipping!`;
          const progress = Math.min(
            100,
            (frozenTotal / FROZEN_THRESHOLD) * 100
          );
          progressBar.style.width = `${progress}%`;
        }
      } else if (hasDry) {
        // Only dry items
        const remaining = Math.max(0, DRY_THRESHOLD - dryTotal);
        if (remaining === 0) {
          messageEl.innerHTML = freeShippingMessage;
          progressBar.style.width = "100%";
        } else {
          //amountEl.textContent = `$${remaining.toFixed(2)}`;
           messageEl.innerHTML = `Spend $${remaining.toFixed(2)} more to get free shipping!`;
          const progress = Math.min(100, (dryTotal / DRY_THRESHOLD) * 100);
          progressBar.style.width = `${progress}%`;
        }
      }

      el.style.display = ""; // Always show the element
    });

    //publishFrozenCartState(hasFrozen, hasDry, frozenProducts.length, true);
    publishFrozenCartState(
    hasFrozen,
    hasDry,
    typeof frozenProducts !== 'undefined' ? frozenProducts.length : 0,
    true
);
  } catch (err) {
    console.error("Error checking cart:", err);
    publishFrozenCartState(false, false, 0, false);
  }
}

// Initial check
checkCartTagAndToggle();

// --- Listen for cart changes ---
// Intercept fetch requests to /cart/add or /cart/change
(function() {
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = args[0];
    if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change'))) {
      checkCartTagAndToggle();
    }
    return response;
  };
})();

// Frozen shipping gate, isolated behind a shop toggle.
;(() => {
  const KEY = "__geoCombinedGate";
  const CACHE_KEY = "__geoCombinedGateState";

  if (!window.frozenShippingGateEnabled) {
    window[KEY]?.detach?.();
    return;
  }

  window[KEY]?.detach?.();

  const norm = (v) => String(v ?? "").replace(/\s+/g, " ").trim().toLowerCase();
  const isVisible = (el) =>
    !!el &&
    getComputedStyle(el).display !== "none" &&
    getComputedStyle(el).visibility !== "hidden" &&
    el.getClientRects().length > 0;

  const allowedRaw = [...new Set((window.allowedFrozenStates || []).map((v) => String(v).trim()).filter(Boolean))];
  const allowed = allowedRaw.map(norm);

  if (!allowedRaw.length) {
    console.warn("[geo-gate] allowedFrozenStates is empty.");
    return;
  }

  const stateCache =
    window[CACHE_KEY] ||
    (window[CACHE_KEY] = {
      lastSubmittedNewState: "",
      lastResolvedSavedAddressState: "",
      lastSubmittedAddressSnapshot: null,
      lastEditFormElement: null,
      lastEditAddressOriginalSnapshot: null,
      lastEditAddressAt: 0,
    });
  const runtime = {
    root: null,
    rootObserver: null,
    bodyObserver: null,
    attachTimer: null,
    syncTimer: null,
    detached: false,
  };
  const snapshots = { saved: "", new: "" };
  const cartScope = {
    ready: false,
    hasFrozen: false,
    frozenProductsLength: 0,
  };

  const syncCartScopeFromWindow = () => {
    const state = window.__geoFrozenCartState;
    if (state && typeof state.ready === "boolean") {
      if (!state.ready) {
        return false;
      }

      cartScope.ready = !!state.ready;
      cartScope.hasFrozen = !!state.hasFrozen;
      const lengthFromState = Number(state.frozenProductsLength);
      cartScope.frozenProductsLength = Number.isFinite(lengthFromState)
        ? Math.max(0, lengthFromState)
        : cartScope.hasFrozen
          ? 1
          : 0;
      return true;
    }

    if (typeof window.__geoFrozenProductsLength === "number") {
      cartScope.ready = true;
      cartScope.frozenProductsLength = Math.max(0, window.__geoFrozenProductsLength);
      cartScope.hasFrozen = cartScope.frozenProductsLength > 0;
      return true;
    }

    if (typeof window.__geoFrozenCartHasFrozenItem === "boolean") {
      cartScope.ready = true;
      cartScope.hasFrozen = window.__geoFrozenCartHasFrozenItem;
      cartScope.frozenProductsLength = window.__geoFrozenCartHasFrozenItem ? 1 : 0;
      return true;
    }

    return false;
  };

  const isFrozenGateActive = () => {
    syncCartScopeFromWindow();
    return cartScope.ready && cartScope.frozenProductsLength > 0;
  };

  const clearMsg = (mode) => {
    runtime.root?.querySelectorAll(`.geo-warning-box[data-geo-mode="${mode}"]`).forEach((el) => el.remove());
  };

  const showMsg = (mode, mount, text) => {
    if (!mount) return;

    clearMsg(mode);

    const box = document.createElement("div");
    box.className = "geo-warning-box mmq-warning-box";
    box.dataset.geoMode = mode;
    box.style.cssText = `
      background:#fff8f0;
      border:1px solid #f97322;
      border-radius:8px;
      padding:12px 16px;
      margin-bottom:10px;
      color:#9a3412;
      font-size:14px;
      line-height:1.4;
      font-weight:500;
      white-space:pre-line;
    `;
    box.textContent = `⚠️ ${text}`;

    mount.insertBefore(box, mount.firstChild);
  };

  const setButton = (btn, disabled) => {
    if (!btn) return;
    if ("disabled" in btn) btn.disabled = disabled;
    btn.setAttribute("aria-disabled", disabled ? "true" : "false");
    btn.style.opacity = disabled ? "0.6" : "1";
    btn.style.cursor = disabled ? "not-allowed" : "pointer";
  };

  const findSavedContinueButton = () =>
    runtime.root
      ? [...runtime.root.querySelectorAll("button, a")]
          .filter(isVisible)
          .find((btn) => {
            const t = norm(btn.textContent);
            return t.includes("continue") && !t.includes("continue and use this address");
          }) || null
      : null;

  const findSavedAddressLabel = () => {
    if (!runtime.root) return null;

    const labels = [...runtime.root.querySelectorAll('label[for^="delivery-address-"]')].filter(isVisible);
    return (
      labels.find((l) => l.querySelector('input[name="delivery-address"]')?.checked) ||
      labels.find((l) => /bg-primary-light|border-secondary/.test(l.className)) ||
      labels[0] ||
      null
    );
  };

  const findSavedAddressSelect = () => {
    if (!runtime.root) return null;

    const selects = [...runtime.root.querySelectorAll("select")].filter(isVisible);

    return (
      selects.find((select) => {
        const options = [...select.options];
        if (options.length < 2 || options.length > 20) return false;

        const text = options.map((o) => norm(o.textContent || o.value || "")).join(" ");
        if (!text) return false;

        if (text.includes("alabama") && text.includes("wyoming") && text.includes("california")) {
          return false;
        }

        return /,/.test(text) || /\b\d{5}(?:-\d{4})?\b/.test(text);
      }) || null
    );
  };

  const US_STATE_NAME_BY_KEY = new Map([
    ["alabama", "Alabama"],
    ["al", "Alabama"],
    ["alaska", "Alaska"],
    ["ak", "Alaska"],
    ["arizona", "Arizona"],
    ["az", "Arizona"],
    ["arkansas", "Arkansas"],
    ["ar", "Arkansas"],
    ["california", "California"],
    ["ca", "California"],
    ["colorado", "Colorado"],
    ["co", "Colorado"],
    ["connecticut", "Connecticut"],
    ["ct", "Connecticut"],
    ["delaware", "Delaware"],
    ["de", "Delaware"],
    ["florida", "Florida"],
    ["fl", "Florida"],
    ["georgia", "Georgia"],
    ["ga", "Georgia"],
    ["hawaii", "Hawaii"],
    ["hi", "Hawaii"],
    ["idaho", "Idaho"],
    ["id", "Idaho"],
    ["illinois", "Illinois"],
    ["il", "Illinois"],
    ["indiana", "Indiana"],
    ["in", "Indiana"],
    ["iowa", "Iowa"],
    ["ia", "Iowa"],
    ["kansas", "Kansas"],
    ["ks", "Kansas"],
    ["kentucky", "Kentucky"],
    ["ky", "Kentucky"],
    ["louisiana", "Louisiana"],
    ["la", "Louisiana"],
    ["maine", "Maine"],
    ["me", "Maine"],
    ["maryland", "Maryland"],
    ["md", "Maryland"],
    ["massachusetts", "Massachusetts"],
    ["ma", "Massachusetts"],
    ["michigan", "Michigan"],
    ["mi", "Michigan"],
    ["minnesota", "Minnesota"],
    ["mn", "Minnesota"],
    ["mississippi", "Mississippi"],
    ["ms", "Mississippi"],
    ["missouri", "Missouri"],
    ["mo", "Missouri"],
    ["montana", "Montana"],
    ["mt", "Montana"],
    ["nebraska", "Nebraska"],
    ["ne", "Nebraska"],
    ["nevada", "Nevada"],
    ["nv", "Nevada"],
    ["new hampshire", "New Hampshire"],
    ["nh", "New Hampshire"],
    ["new jersey", "New Jersey"],
    ["nj", "New Jersey"],
    ["new mexico", "New Mexico"],
    ["nm", "New Mexico"],
    ["new york", "New York"],
    ["ny", "New York"],
    ["north carolina", "North Carolina"],
    ["nc", "North Carolina"],
    ["north dakota", "North Dakota"],
    ["nd", "North Dakota"],
    ["ohio", "Ohio"],
    ["oh", "Ohio"],
    ["oklahoma", "Oklahoma"],
    ["ok", "Oklahoma"],
    ["oregon", "Oregon"],
    ["or", "Oregon"],
    ["pennsylvania", "Pennsylvania"],
    ["pa", "Pennsylvania"],
    ["rhode island", "Rhode Island"],
    ["ri", "Rhode Island"],
    ["south carolina", "South Carolina"],
    ["sc", "South Carolina"],
    ["south dakota", "South Dakota"],
    ["sd", "South Dakota"],
    ["tennessee", "Tennessee"],
    ["tn", "Tennessee"],
    ["texas", "Texas"],
    ["tx", "Texas"],
    ["utah", "Utah"],
    ["ut", "Utah"],
    ["vermont", "Vermont"],
    ["vt", "Vermont"],
    ["virginia", "Virginia"],
    ["va", "Virginia"],
    ["washington", "Washington"],
    ["wa", "Washington"],
    ["west virginia", "West Virginia"],
    ["wv", "West Virginia"],
    ["wisconsin", "Wisconsin"],
    ["wi", "Wisconsin"],
    ["wyoming", "Wyoming"],
    ["wy", "Wyoming"],
    ["district of columbia", "District of Columbia"],
    ["dc", "District of Columbia"],
    ["washington dc", "District of Columbia"],
  ]);

  const extractStateFromAddressText = (text) => {
    const parts = String(text ?? "")
      .replace(/\s+/g, " ")
      .trim()
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean);

    for (let i = parts.length - 1; i >= 0; i--) {
      const candidate = norm(parts[i]).replace(/\./g, "");
      if (!candidate) continue;
      if (/^\d{5}(?:-\d{4})?$/.test(candidate)) continue;

      const matched = US_STATE_NAME_BY_KEY.get(candidate);
      if (matched) return matched;
    }

    return "";
  };

  const normalizeAddressValue = (value) => String(value ?? "").replace(/\s+/g, " ").trim();

  const getAddressSignature = (address) =>
    [
      normalizeAddressValue(address?.first_name).toLowerCase(),
      normalizeAddressValue(address?.last_name).toLowerCase(),
      normalizeAddressValue(address?.address1).toLowerCase(),
      normalizeAddressValue(address?.address2).toLowerCase(),
      normalizeAddressValue(address?.city).toLowerCase(),
      normalizeAddressValue(address?.province).toLowerCase(),
      normalizeAddressValue(address?.zip).toLowerCase(),
    ].join("|");

  const getAddressCoreSignature = (address) =>
    [
      normalizeAddressValue(address?.first_name).toLowerCase(),
      normalizeAddressValue(address?.last_name).toLowerCase(),
      normalizeAddressValue(address?.address1).toLowerCase(),
      normalizeAddressValue(address?.address2).toLowerCase(),
      normalizeAddressValue(address?.city).toLowerCase(),
      normalizeAddressValue(address?.zip).toLowerCase(),
    ].join("|");

  const EDIT_OVERRIDE_TTL_MS = 5 * 60 * 1000;

  const addressTextMatchesCore = (text, address) => {
    const normalizedText = norm(text);
    if (!normalizedText || !address) return false;

    const requiredParts = [
      address.first_name,
      address.last_name,
      address.address1,
      address.address2,
      address.city,
      address.zip,
    ]
      .map((part) => norm(part))
      .filter(Boolean);

    return requiredParts.every((part) => normalizedText.includes(part));
  };

  const getRecentEditedStateOverride = (text) => {
    const original = stateCache.lastEditAddressOriginalSnapshot;
    const updated = stateCache.lastSubmittedAddressSnapshot;
    if (!original || !updated?.province || !stateCache.lastEditAddressAt) return "";
    if (Date.now() - stateCache.lastEditAddressAt > EDIT_OVERRIDE_TTL_MS) return "";

    return addressTextMatchesCore(text, original) ? String(updated.province || "").trim() : "";
  };

  const getKnownCustomerAddresses = () => {
    const baseAddresses = Array.isArray(window.customerAddresses)
      ? [...window.customerAddresses]
      : Array.isArray(window.__geoCustomerAddresses)
        ? [...window.__geoCustomerAddresses]
        : [];
    const cachedAddress = stateCache.lastSubmittedAddressSnapshot;

    if (!cachedAddress) {
      return baseAddresses;
    }

    const cachedSignature = getAddressSignature(cachedAddress);
    if (!baseAddresses.some((address) => getAddressSignature(address) === cachedSignature)) {
      baseAddresses.push(cachedAddress);
    }

    return baseAddresses;
  };

  const getFormFieldValue = (formData, ...names) => {
    for (const name of names) {
      const value = formData.get(name);
      if (value != null && String(value).trim()) {
        return normalizeAddressValue(value);
      }
    }

    return "";
  };

  const buildAddressSnapshotFromForm = (form, stateOverride = "") => {
    if (!form) return null;

    const formData = new FormData(form);
    const stateSelect = findStateSelect(form);
    const countrySelect = findCountrySelect(form);
    const provinceRaw = normalizeAddressValue(
      stateOverride ||
        resolveSelectState(stateSelect) ||
        getFormFieldValue(formData, "address[province]", "province", "state", "address[state]")
    );
    const province = extractStateFromAddressText(provinceRaw) || provinceRaw;
    const country =
      resolveSelectState(countrySelect) ||
      getFormFieldValue(formData, "address[country]", "country") ||
      "";
    const addressId = `__geo-${Date.now()}`;

    return {
      id: addressId,
      address_id: addressId,
      first_name: getFormFieldValue(formData, "address[first_name]", "firstName", "first_name") || "",
      last_name: getFormFieldValue(formData, "address[last_name]", "lastName", "last_name") || "",
      company: getFormFieldValue(formData, "address[company]", "company") || "",
      address1:
        getFormFieldValue(formData, "address[address1]", "addressLine1", "address1") || "",
      address2:
        getFormFieldValue(formData, "address[address2]", "addressLine2", "address2") || "",
      city: getFormFieldValue(formData, "address[city]", "city") || "",
      province,
      zip:
        getFormFieldValue(formData, "address[zip]", "postalCode", "postal_code", "zip") || "",
      country,
      phone: getFormFieldValue(formData, "address[phone]", "phone") || "",
      __source: "sparklayer-new-address-form",
      __synthetic: true,
    };
  };

  const upsertCustomerAddressCache = (snapshot, matchSnapshot = null) => {
    if (!snapshot) return;

    const merged = getKnownCustomerAddresses();
    const targetSnapshot = matchSnapshot || snapshot;
    const targetSignature = matchSnapshot ? getAddressCoreSignature(targetSnapshot) : getAddressSignature(targetSnapshot);
    const targetId = String(targetSnapshot?.id ?? targetSnapshot?.address_id ?? targetSnapshot?.addressId ?? "").trim();
    const existingIndex = merged.findIndex((address) => {
      const addressId = String(address?.id ?? address?.address_id ?? address?.addressId ?? "").trim();

      return (
        (addressId && targetId && addressId === targetId) ||
        (matchSnapshot ? getAddressCoreSignature(address) === targetSignature : getAddressSignature(address) === targetSignature)
      );
    });

    if (existingIndex >= 0) {
      merged[existingIndex] = { ...merged[existingIndex], ...snapshot };
    } else {
      merged.push(snapshot);
    }

    stateCache.lastSubmittedAddressSnapshot = snapshot;
    stateCache.lastSubmittedNewState = snapshot.province || stateCache.lastSubmittedNewState || "";
    if (snapshot.province) {
      stateCache.lastResolvedSavedAddressState = snapshot.province;
    }

    try {
      window.customerAddresses = merged;
      window.__geoCustomerAddresses = merged;
    } catch (err) {
      console.warn("[geo-gate] Could not update window.customerAddresses directly:", err);
      window.__geoCustomerAddresses = merged;
    }

    window.dispatchEvent(
      new CustomEvent("mmq:customer-addresses-updated", { detail: merged.slice() })
    );
  };

  const rememberSubmittedAddress = (form, state, matchSnapshot = null) => {
    const snapshot = buildAddressSnapshotFromForm(form, state);
    if (!snapshot) return;
    upsertCustomerAddressCache(snapshot, matchSnapshot);
  };

  const getSavedAddressStateFromSelect = (select) => {
    const addresses = getKnownCustomerAddresses();
    if (!select || !addresses.length) return "";

    const selectedOption = select.selectedOptions?.[0] || select.options?.[select.selectedIndex] || null;
    const optionText = String(selectedOption?.textContent || "").replace(/\s+/g, " ").trim();
    const optionValue = String(selectedOption?.value || select.value || "").trim();
    const selectedIndex = Number.isInteger(select.selectedIndex) ? select.selectedIndex : -1;
    const text = norm(optionText);

    const editedOverride = getRecentEditedStateOverride(optionText);
    if (editedOverride) return editedOverride;

    const parsedState = extractStateFromAddressText(optionText);
    if (parsedState) return parsedState;

    let bestState = "";
    let bestScore = 0;

    addresses.forEach((a, idx) => {
      let score = 0;
      const addressId = String(a?.id ?? a?.address_id ?? a?.addressId ?? "").trim();

      if (addressId && optionValue && addressId === optionValue) score += 20;

      const addressDigits = addressId.replace(/\D/g, "");
      const optionDigits = optionValue.replace(/\D/g, "");
      if (addressDigits && optionDigits && addressDigits === optionDigits) score += 12;

      if (text && norm(a.province) && text.includes(norm(a.province))) score += 6;
      if (text && norm(a.city) && text.includes(norm(a.city))) score += 4;
      if (text && norm(a.address1) && text.includes(norm(a.address1))) score += 4;
      if (text && norm(a.address2) && text.includes(norm(a.address2))) score += 1;
      if (text && norm(a.first_name) && text.includes(norm(a.first_name))) score += 1;
      if (text && norm(a.last_name) && text.includes(norm(a.last_name))) score += 1;
      if (text && String(a.zip || "").trim() && text.includes(norm(a.zip))) score += 4;
      if (idx === selectedIndex) score += 2;

      if (score > bestScore) {
        bestScore = score;
        bestState = String(a.province || "").trim();
      }
    });

    return bestScore > 0 ? bestState : "";
  };

  const getSavedAddressStateFromLabel = (label) => {
    const addresses = getKnownCustomerAddresses();
    if (!label || !addresses.length) return "";

    const text = String(label.getAttribute("aria-label") || label.innerText || "").replace(/\s+/g, " ").trim();
    const editedOverride = getRecentEditedStateOverride(text);
    if (editedOverride) return editedOverride;

    const parsedState = extractStateFromAddressText(text);
    if (parsedState) return parsedState;
    const zip = text.match(/\b\d{5}(?:-\d{4})?\b/)?.[0] || "";

    const scored = addresses
      .map((a) => {
        let score = 0;
        if (zip && String(a.zip) === zip) score += 10;
        if (text && norm(text).includes(norm(a.province))) score += 5;
        if (text && norm(text).includes(norm(a.city))) score += 2;
        if (text && norm(text).includes(norm(a.address1))) score += 2;
        if (text && norm(text).includes(norm(a.first_name))) score += 1;
        if (text && norm(text).includes(norm(a.last_name))) score += 1;
        return { a, score };
      })
      .sort((x, y) => y.score - x.score);

    const match = scored[0]?.score ? scored[0].a : null;
    return String(match?.province || "").trim();
  };

  const getSavedAddressState = () => {
    const select = findSavedAddressSelect();
    if (select) {
      const fromSelect = getSavedAddressStateFromSelect(select);
      if (fromSelect) {
        stateCache.lastResolvedSavedAddressState = fromSelect;
        return fromSelect;
      }
    }

    const label = findSavedAddressLabel();
    if (label) {
      const fromLabel = getSavedAddressStateFromLabel(label);
      if (fromLabel) {
        stateCache.lastResolvedSavedAddressState = fromLabel;
        return fromLabel;
      }
    }

    if (stateCache.lastResolvedSavedAddressState) {
      return stateCache.lastResolvedSavedAddressState;
    }

    return stateCache.lastSubmittedNewState || "";
  };

  const findNewAddressForm = () => {
    if (!runtime.root) return null;

    const submit = [...runtime.root.querySelectorAll('button[type="submit"]')]
      .filter(isVisible)
      .find((btn) => norm(btn.textContent).includes("continue and use this address"));

    return submit?.closest("form") || null;
  };

  const findStateSelect = (form) => {
    if (!form) return null;

    const byLabel = [...form.querySelectorAll("div")].find((wrapper) => {
      const label = wrapper.querySelector("label");
      const select = wrapper.querySelector("select");
      return label && select && norm(label.textContent).startsWith("state");
    });

    return byLabel?.querySelector("select") || [...form.querySelectorAll("select")].find(isVisible) || null;
  };

  const findCountrySelect = (form) => {
    if (!form) return null;

    const byLabel = [...form.querySelectorAll("div")].find((wrapper) => {
      const label = wrapper.querySelector("label");
      const select = wrapper.querySelector("select");
      return label && select && norm(label.textContent).startsWith("country");
    });

    return byLabel?.querySelector("select") || null;
  };

  const resolveSelectState = (select) => {
    if (!select) return "";

    const selectedText = String(select.selectedOptions?.[0]?.textContent || "").trim();
    if (selectedText && !/^state\s*\*?$/i.test(norm(selectedText))) return selectedText;

    const value = String(select.value || "").trim();
    if (value) {
      const option = [...select.options].find((o) => String(o.value).trim() === value);
      return String(option?.textContent || value).trim();
    }

    return "";
  };

  const getNewAddressState = () => {
    const form = findNewAddressForm();
    const select = findStateSelect(form);
    if (!select) return "";

    return resolveSelectState(select);
  };

  const findEditAddressForm = () => {
    if (!runtime.root) return null;

    const submit = [...runtime.root.querySelectorAll('button[type="submit"]')]
      .filter(isVisible)
      .find((btn) => norm(btn.textContent).includes("save address"));

    return submit?.closest("form") || null;
  };

  const captureEditAddressContext = (reason = "") => {
    const form = findEditAddressForm();
    if (!form) {
      stateCache.lastEditFormElement = null;
      stateCache.lastEditAddressOriginalSnapshot = null;
      return null;
    }

    if (stateCache.lastEditFormElement !== form) {
      stateCache.lastEditFormElement = form;
      stateCache.lastEditAddressOriginalSnapshot = buildAddressSnapshotFromForm(form);
      console.log("[geo-gate] captured edit address context", reason);
    }

    return form;
  };

  const resetGateUi = () => {
    clearMsg("saved");
    clearMsg("new");
    snapshots.saved = "";
    snapshots.new = "";

    const savedBtn = findSavedContinueButton();
    if (savedBtn) setButton(savedBtn, false);

    const form = findNewAddressForm();
    const submit = form?.querySelector('button[type="submit"]');
    if (submit) setButton(submit, false);
  };

  const syncSaved = (reason = "") => {
    const btn = findSavedContinueButton();
    if (!btn) return;

    if (!isFrozenGateActive()) {
      clearMsg("saved");
      setButton(btn, false);
      return;
    }

    const state = getSavedAddressState();
    const isAllowed = !!state && allowed.includes(norm(state));
    const snapshot = `saved|${state || "NONE"}|${isAllowed ? "allowed" : "blocked"}`;

    if (snapshots.saved === snapshot && (isAllowed || runtime.root?.querySelector('.geo-warning-box[data-geo-mode="saved"]'))) return;
    snapshots.saved = snapshot;

    const mount = btn.parentElement || runtime.root;

    if (!state) {
      showMsg("saved", mount, "Please select an address before continuing.");
      setButton(btn, true);
      console.log("[geo-gate:saved] blocked: no address", reason);
      return;
    }

    if (isAllowed) {
      clearMsg("saved");
      setButton(btn, false);
      console.log("[geo-gate:saved] allowed:", state, reason);
    } else {
      showMsg(
        "saved",
        mount,
        `We only ship frozen foods to regions where we can guarantee they arrive in perfect condition. Availability is currently limited to ${allowedRaw.join(", ")}. Watch for updates as we expand our national reach.\nCurrent state: ${state}`
      );
      setButton(btn, true);
      console.log("[geo-gate:saved] blocked:", state, reason);
    }
  };

  const syncNew = (reason = "") => {
    const form = findNewAddressForm();
    if (!form) return;

    const btn = form.querySelector('button[type="submit"]');
    if (!btn) return;

    if (!isFrozenGateActive()) {
      clearMsg("new");
      setButton(btn, false);
      return;
    }

    const state = getNewAddressState();
    const isAllowed = !!state && allowed.includes(norm(state));
    const snapshot = `new|${state || "NONE"}|${isAllowed ? "allowed" : "blocked"}`;

    if (snapshots.new === snapshot && (isAllowed || runtime.root?.querySelector('.geo-warning-box[data-geo-mode="new"]'))) return;
    snapshots.new = snapshot;

    if (!state) {
      showMsg("new", form, "Please select an address before continuing.");
      setButton(btn, true);
      console.log("[geo-gate:new] blocked: no address", reason);
      return;
    }

    if (isAllowed) {
      clearMsg("new");
      setButton(btn, false);
      console.log("[geo-gate:new] allowed:", state, reason);
    } else {
      showMsg(
        "new",
        form,
        `We only ship frozen foods to regions where we can guarantee they arrive in perfect condition. Availability is currently limited to ${allowedRaw.join(", ")}. Watch for updates as we expand our national reach.\nCurrent state: ${state}`
      );
      setButton(btn, true);
      console.log("[geo-gate:new] blocked:", state, reason);
    }
  };

  const syncActive = (reason = "") => {
    if (!isFrozenGateActive()) {
      resetGateUi();
      return;
    }

    const editForm = captureEditAddressContext(reason);
    if (editForm) {
      clearMsg("saved");
      clearMsg("new");
      return;
    }

    if (findNewAddressForm()) {
      syncNew(reason);
      return;
    }

    if (findSavedContinueButton()) {
      syncSaved(reason);
      return;
    }

    clearMsg("saved");
    clearMsg("new");
  };

  const scheduleSync = (reason = "") => {
    clearTimeout(runtime.syncTimer);
    runtime.syncTimer = setTimeout(() => syncActive(reason), 60);
  };

  const onFrozenCartStatus = () => {
    syncCartScopeFromWindow();
    scheduleSync("cart-status");
  };

  const onClick = (e) => {
    if (!isFrozenGateActive()) return;

    const btn = e.target?.closest?.("button, a");
    if (!btn) return;

    const text = norm(btn.textContent);

    if (text.includes("add a new address") || text.includes("cancel")) {
      setTimeout(() => scheduleSync("nav"), 150);
      return;
    }

    if (text === "edit" || text.includes("edit address")) {
      setTimeout(() => scheduleSync("edit-open"), 120);
      return;
    }

    if (text.includes("continue and use this address")) {
      const form = btn.closest("form") || findNewAddressForm();
      const state = getNewAddressState();
      if (!state || !allowed.includes(norm(state))) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        syncNew("new-click-blocked");
        return;
      }

      rememberSubmittedAddress(form, state);
      setTimeout(() => scheduleSync("new-submit"), 150);
      return;
    }

    if (text.includes("continue") && !text.includes("continue and use this address")) {
      const state = getSavedAddressState();
      if (!state || !allowed.includes(norm(state))) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        syncSaved("saved-click-blocked");
      }
    }
  };

  const onChange = (e) => {
    if (!isFrozenGateActive()) return;

    if (e.target?.matches?.("input, select, textarea")) {
      scheduleSync("change");
    }
  };

  const onSubmit = (e) => {
    if (!isFrozenGateActive()) return;

    const form = e.target?.closest?.("form");
    if (!form) return;

    const submit = form.querySelector('button[type="submit"]');
    if (!submit) return;

    const submitText = norm(submit.textContent);

    if (submitText.includes("save address")) {
      captureEditAddressContext("submit");
      const originalSnapshot =
        stateCache.lastEditAddressOriginalSnapshot || buildAddressSnapshotFromForm(form);
      if (originalSnapshot) {
        rememberSubmittedAddress(form, "", originalSnapshot);
        stateCache.lastEditAddressAt = Date.now();
      }
      stateCache.lastResolvedSavedAddressState = stateCache.lastSubmittedAddressSnapshot?.province || stateCache.lastResolvedSavedAddressState;
      setTimeout(() => scheduleSync("edit-submit"), 150);
      return;
    }

    if (!submitText.includes("continue and use this address")) return;

    const state = getNewAddressState();
    if (!state || !allowed.includes(norm(state))) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      syncNew("new-submit-blocked");
      return;
    }

    rememberSubmittedAddress(form, state);
    setTimeout(() => scheduleSync("new-submit"), 150);
  };

  const mutationIsRelevant = (mutations) =>
    mutations.some((mutation) =>
      [...mutation.addedNodes, ...mutation.removedNodes].some((node) => {
        if (!(node instanceof Element)) return false;
        if (node.matches?.(".geo-warning-box, .mmq-warning-box")) return false;
        return true;
      })
    );

  const detachRoot = () => {
    if (!runtime.root) return;

    runtime.root.removeEventListener("click", onClick, true);
    runtime.root.removeEventListener("change", onChange, true);
    runtime.root.removeEventListener("input", onChange, true);
    runtime.root.removeEventListener("submit", onSubmit, true);
    runtime.rootObserver?.disconnect();
    runtime.rootObserver = null;
    clearTimeout(runtime.syncTimer);
    runtime.syncTimer = null;
    clearMsg("saved");
    clearMsg("new");
    runtime.root = null;
  };

  const attachRoot = (nextRoot) => {
    if (!nextRoot || runtime.detached) return false;
    if (runtime.root === nextRoot) return true;

    detachRoot();
    runtime.root = nextRoot;

    runtime.root.addEventListener("click", onClick, true);
    runtime.root.addEventListener("change", onChange, true);
    runtime.root.addEventListener("input", onChange, true);
    runtime.root.addEventListener("submit", onSubmit, true);

    runtime.rootObserver = new MutationObserver((mutations) => {
      if (mutationIsRelevant(mutations)) scheduleSync("mutate");
    });
    runtime.rootObserver.observe(runtime.root, { childList: true, subtree: true });

    console.log("[geo-gate] attached. allowed states:", allowedRaw);
    syncActive("init");
    setTimeout(() => syncActive("init-retry"), 180);
    return true;
  };

  const tryAttach = () => {
    if (runtime.detached || !window.frozenShippingGateEnabled) return false;

    const nextRoot = document.querySelector("spark-drawer")?.shadowRoot || null;
    return attachRoot(nextRoot);
  };

  const startAttachTimer = () => {
    if (runtime.attachTimer || runtime.detached) return;

    runtime.attachTimer = setInterval(() => {
      if (runtime.detached) {
        clearInterval(runtime.attachTimer);
        runtime.attachTimer = null;
        return;
      }

      if (!window.frozenShippingGateEnabled) {
        window[KEY]?.detach?.();
        return;
      }

      if (tryAttach()) {
        clearInterval(runtime.attachTimer);
        runtime.attachTimer = null;
      }
    }, 250);
  };

  const startBodyObserver = () => {
    if (runtime.bodyObserver) return;

    runtime.bodyObserver = new MutationObserver((mutations) => {
      if (runtime.detached) return;
      if (!window.frozenShippingGateEnabled) {
        window[KEY]?.detach?.();
        return;
      }

      const relevant = mutations.some((mutation) =>
        [...mutation.addedNodes, ...mutation.removedNodes].some(
          (node) => node.nodeType === 1 && node.tagName?.toLowerCase() === "spark-drawer"
        )
      );

      if (relevant) {
        if (!tryAttach()) startAttachTimer();
      }
    });

    runtime.bodyObserver.observe(document.body, { childList: true, subtree: true });
  };

  const detach = () => {
    runtime.detached = true;
    detachRoot();
    runtime.bodyObserver?.disconnect();
    runtime.bodyObserver = null;
    clearInterval(runtime.attachTimer);
    runtime.attachTimer = null;
    window.removeEventListener("mmq:frozen-cart-status", onFrozenCartStatus);
    window[KEY] = { detach, sync: syncActive };
  };

  window[KEY] = {
    detach,
    sync: syncActive,
  };

  window.addEventListener("mmq:frozen-cart-status", onFrozenCartStatus);

  startBodyObserver();
  if (!tryAttach()) startAttachTimer();
})();

// --- Tab visibility check ---
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) checkCartTagAndToggle();
});


// SparkLayer - Show ONLY Allowed Shipping Methods Based on Product Tags (Coldcart)
(function () {
    'use strict';

    console.clear();
    console.log('%c🌟 SPARKLAYER SHIPPING FILTER (COLDCART MODE)', 'background: #000; color: #00ff00; font-size: 16px; padding: 10px; font-weight: bold;');

    const productTagCache = {};
    let cartStateCache = null;
    let lastCartHash = null;
    let lastFilteredHash = null;
    let isFiltering = false;
    let hasAppliedInitialHide = false;
    let lastShippingRadioCount = 0;
    let shippingStepVisible = false;
    let debounceTimer = null;
    let shippingDetected = false;


    const SHOPIFY_STORE = "bossnationbrand.myshopify.com";
    const STOREFRONT_TOKEN = "981d248c9420e05cd5aaa55e466e594a";

    // ------------------------------
    // Check if shipping step is currently visible
    // ------------------------------
    function isShippingStepVisible() {
        const sparkDrawer = document.querySelector('spark-drawer');
        if (!sparkDrawer?.shadowRoot) return false;

        const shippingRadios = findShippingMethodsInShadowDOM();
        if (!shippingRadios || shippingRadios.length === 0) return false;

        const firstRadio = shippingRadios[0];
        const label = firstRadio.closest('label');
        if (!label) return false;

        const computedStyle = window.getComputedStyle(label);
        const isDisplayed = computedStyle.display !== 'none';
        const isVisible = computedStyle.visibility !== 'hidden';
        const hasSize = label.offsetWidth > 0 && label.offsetHeight > 0;

        return isDisplayed && isVisible && hasSize;
    }

    // ------------------------------
    // Debounced UI change detection - STRICTER
    // ------------------------------
    function detectUIChanges() {
        // Don't trigger if already filtering
        if (isFiltering) {
            console.log('⏸️ Skipping UI detection - filtering in progress');
            return;
        }

        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }

        debounceTimer = setTimeout(() => {
            performUICheck();
        }, 500); // Increased from 300ms to 500ms
    }

    // ------------------------------
    // Actual UI check logic (debounced) - PREVENT UNNECESSARY FILTERS
    // ------------------------------
    function performUICheck() {
        // Don't run if filtering is in progress
        if (isFiltering) {
            console.log('⏸️ Skipping UI check - filtering in progress');
            return;
        }

        const shippingRadios = findShippingMethodsInShadowDOM();
        const currentCount = shippingRadios ? shippingRadios.length : 0;
        const currentlyVisible = isShippingStepVisible();

        // Case 1: Shipping step just became visible (navigation back)
        if (currentlyVisible && !shippingStepVisible && currentCount > 0) {
            console.log('🔄 Shipping step became visible - re-initializing...');
            shippingStepVisible = true;
            hasAppliedInitialHide = false;
            lastFilteredHash = null;
            shippingDetected = false;

            setTimeout(() => {
                hideAllShippingMethods();
                filterShippingMethodsByTags(true);
            }, 150);
            return;
        }

        // Case 2: Shipping methods DOM rebuilt (count changed while visible)
        if (currentlyVisible && currentCount > 0 && lastShippingRadioCount > 0 && currentCount !== lastShippingRadioCount) {
            console.log(`🔄 Shipping methods DOM rebuilt: ${lastShippingRadioCount} → ${currentCount}`);
            hasAppliedInitialHide = false;
            lastFilteredHash = null;

            setTimeout(() => {
                hideAllShippingMethods();
                filterShippingMethodsByTags(true);
            }, 150);
        }

        // Case 3: Step became hidden (navigated away)
        if (!currentlyVisible && shippingStepVisible) {
            console.log('👋 Shipping step hidden - resetting state');
            shippingStepVisible = false;
        }


        if (currentCount > 0) {
            lastShippingRadioCount = currentCount;
        }
        const sparkDrawer = document.querySelector('spark-drawer');

        const overlay = sparkDrawer?.shadowRoot?.querySelector('.shipping-filter-overlay');
        if (overlay) {
            //hideLoadingOverlay();
            filterShippingMethodsByTags(true);

        }

        // hideLoadingOverlay();
    }

    function findShippingMethodsInShadowDOM() {
        const sparkDrawer = document.querySelector('spark-drawer');
        if (!sparkDrawer?.shadowRoot) return null;
        const radios = sparkDrawer.shadowRoot.querySelectorAll('input[name="shipping-method"]');
        return radios.length ? radios : null;
    }

    // ------------------------------
    // Show/Hide Loading Overlay - FIXED VERSION
    // ------------------------------
    function showLoadingOverlay() {
        const sparkDrawer = document.querySelector('spark-drawer');
        if (!sparkDrawer?.shadowRoot) return;

        let overlay = sparkDrawer.shadowRoot.querySelector('.shipping-filter-overlay');
        if (overlay) return;

        console.log('🔴 Showing loading overlay...');

        const shippingRadios = findShippingMethodsInShadowDOM();
        if (!shippingRadios || shippingRadios.length === 0) return;

        const firstRadio = shippingRadios[0];
        const firstLabel = firstRadio.closest('label');

        // Find the shipping container - go up to fieldset or parent container
        let shippingContainer = firstLabel?.closest('fieldset') ||
            firstLabel?.closest('[role="radiogroup"]') ||
            firstLabel?.parentElement?.parentElement;

        if (!shippingContainer) {
            shippingContainer = firstLabel?.parentElement;
        }

        // Create style element for animations if not exists
        let styleEl = sparkDrawer.shadowRoot.querySelector('#shipping-filter-styles');
        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.id = 'shipping-filter-styles';
            styleEl.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes fadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
      `;
            sparkDrawer.shadowRoot.appendChild(styleEl);
        }

        // Make container position relative if needed
        const containerPosition = window.getComputedStyle(shippingContainer).position;
        if (containerPosition === 'static') {
            shippingContainer.style.position = 'relative';
        }

        // Create overlay
        overlay = document.createElement('div');
        overlay.className = 'shipping-filter-overlay';
        overlay.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      min-height:200px;
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      animation: fadeIn 0.2s ease-in;
      border-radius: 8px;
    `;

        const loaderContent = document.createElement('div');
        loaderContent.style.cssText = `
      background: white;
      padding: 24px 32px;
      border-radius: 12px;
      box-shadow: 0 0px 1px #ea0a2a;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 14px;
      border: 2px solid #dc2626;
    `;

        const spinner = document.createElement('div');
        spinner.style.cssText = `
      width: 36px;
      height: 36px;
      border: 3px solid #fee2e2;
      border-top: 3px solid #dc2626;
      border-radius: 50%;
      animation: spin 0.7s linear infinite;
    `;

        const text = document.createElement('div');
        text.textContent = 'Loading Shipping Methods...';
        text.style.cssText = `
      color: #dc2626;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      letter-spacing: 0.3px;
    `;

        loaderContent.appendChild(spinner);
        loaderContent.appendChild(text);
        overlay.appendChild(loaderContent);
        shippingContainer.appendChild(overlay);

        console.log('✅ Overlay shown');
    }

    function hideLoadingOverlay() {
        const sparkDrawer = document.querySelector('spark-drawer');
        if (!sparkDrawer?.shadowRoot) return;

        const overlay = sparkDrawer.shadowRoot.querySelector('.shipping-filter-overlay');
        if (overlay) {
            console.log('🔴 Hiding loading overlay...');
            overlay.style.animation = 'fadeOut 0.15s ease-out';
            setTimeout(() => {
                if (overlay.parentNode) {
                    overlay.remove();
                    console.log('✅ Overlay removed');
                }
            }, 150);
        }
    }

    // ------------------------------
    // Hide all shipping methods immediately
    // ------------------------------
    function hideAllShippingMethods() {
        const shippingRadios = findShippingMethodsInShadowDOM();
        if (!shippingRadios) return false;

        shippingRadios.forEach(radio => {
            const label = radio.closest('label');
            if (label) {
                label.style.display = 'none';
                radio.disabled = true;
            }
        });
        return true;
    }

    // ------------------------------
    // Generate cart hash to detect changes
    // ------------------------------
    function generateCartHash(items) {
        if (!items || items.length === 0) return 'empty';
        return items.map(item => `${item.parentExternalId}-${item.quantity}`).sort().join('|');
    }

    // ------------------------------
    // Fetch tags for a single product
    // ------------------------------
    async function getProductTags(productId) {


        const query = `
      {
        product(id: "gid://shopify/Product/${productId}") {
          tags
        }
      }
    `;
        const res = await fetch(`https://${SHOPIFY_STORE}/api/2025-07/graphql.json`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
            },
            body: JSON.stringify({ query }),
        });
        const data = await res.json();
        const tags = data.data.product?.tags || [];

        productTagCache[productId] = tags;
        return tags;
    }

    // ------------------------------
    // Get cart items using Spark API
    // ------------------------------
    async function getCartItems() {
        try {
            if (!window.spark?.getCart) return [];
            const res = await window.spark.getCart();
            console.log('Cart', res);
            return res.items;
        } catch (err) {
            console.error('Error fetching cart:', err);
            return [];
        }
    }

    // ------------------------------
    // Combine all cart product tags (with caching)
    // ------------------------------
    async function getCartProductTags(forceRefresh = false) {
        const items = await getCartItems();
        const currentHash = generateCartHash(items);

        if (!forceRefresh && lastCartHash === currentHash && cartStateCache) {
            console.log('📦 Using cached cart tags (no changes detected)');
            return cartStateCache;
        }

        console.log('📦 Cart changed - fetching product tags...');
        console.log('📦 Products in cart:', items);

        const cartTags = new Set();
        lastCartHash = currentHash;

        const tagPromises = items.map(async (item) => {
            const productId = item.parentExternalId;
            if (!productId) return;

            const tags = await getProductTags(productId);
            console.log(`  - ${item.name || 'Unknown Product'}`);
            tags.forEach(tag => {
                cartTags.add(tag.toLowerCase());
                console.log(`    Tag: "${tag}"`);
            });
        });

        await Promise.all(tagPromises);

        cartStateCache = cartTags;
        console.log('');
        return cartTags;
    }

    // ------------------------------
    // Get shipping methods container - FIXED
    // ------------------------------
    function getShippingMethodsContainer() {
        const shippingRadios = findShippingMethodsInShadowDOM();
        if (!shippingRadios || shippingRadios.length === 0) return null;

        const firstRadio = shippingRadios[0];
        const firstLabel = firstRadio.closest('label');

        // Go up to find the parent container that holds ALL shipping methods
        let container = firstLabel?.parentElement;

        // Keep going up until we find a container that contains all radio buttons
        while (container && container.parentElement) {
            const radiosInContainer = container.querySelectorAll('input[name="shipping-method"]');
            if (radiosInContainer.length === shippingRadios.length) {
                return container;
            }
            container = container.parentElement;
        }

        return firstLabel?.parentElement;
    }

    // ------------------------------
    // Show/Hide "no methods" message - FIXED
    // ------------------------------
    function showNoMethodsMessage() {
        const container = getShippingMethodsContainer();
        if (!container) return;

        // Remove existing message first
        hideNoMethodsMessage();

        const message = document.createElement('div');
        message.className = 'no-shipping-methods-msg';
        message.style.cssText = `
      padding: 20px; 
      text-align: center; 
      color: #666; 
      font-size: 14px; 
      border: 1px dashed #ccc; 
      border-radius: 8px; 
      margin: 10px 0;
      background: #f9f9f9;
    `;
        message.innerHTML = `
      <p style="margin: 0 0 8px 0; font-weight: 600; color: #dc2626;">⚠️ No shipping methods available</p>
      <p style="margin: 0; font-size: 12px;">Please check your cart items or contact support.</p>
    `;
        container.appendChild(message);
        console.log('⚠️ "No methods" message shown');
    }

    function hideNoMethodsMessage() {
        const sparkDrawer = document.querySelector('spark-drawer');
        if (!sparkDrawer?.shadowRoot) return;

        const existingMsg = sparkDrawer.shadowRoot.querySelector('.no-shipping-methods-msg');
        if (existingMsg) {
            existingMsg.remove();
            console.log('✅ "No methods" message removed');
        }
    }

    // ------------------------------
    // Filter shipping methods by tags - STRICT SINGLE EXECUTION
    // ------------------------------
    async function filterShippingMethodsByTags(forceFilter = false) {
        const shippingRadios = findShippingMethodsInShadowDOM();
        if (!shippingRadios) return;

        // Apply initial hide immediately on first detection
        if (!hasAppliedInitialHide) {
            console.log('🔒 Hiding all shipping methods initially...');
            hideAllShippingMethods();
            hasAppliedInitialHide = true;
        }

        // CRITICAL: Prevent concurrent filtering
        if (isFiltering) {
            console.log('⏸️ ❌ FILTERING BLOCKED - Already in progress');
            return;
        }

        // Check if we need to filter
        const items = await getCartItems();
        const currentHash = generateCartHash(items);

        // Skip if nothing changed since last filter (unless forced)
        if (!forceFilter && lastFilteredHash === currentHash && shippingDetected) {
            console.log('⏭️ ✅ FILTERING SKIPPED - No cart changes (hash: ' + currentHash + ')');
            return;
        }

        // START FILTERING - SET FLAG IMMEDIATELY
        console.log('🔄 ▶️ FILTERING STARTED (hash: ' + currentHash + ')');
        isFiltering = true;
        lastFilteredHash = currentHash;

        // SHOW LOADING OVERLAY
        showLoadingOverlay();

        try {
            if (!shippingDetected) {
                console.log('%c✅ SHIPPING METHODS FOUND IN SHADOW DOM!', 'background: #4CAF50; color: white; font-size: 14px; padding: 10px; font-weight: bold;');
                shippingDetected = true;
            }

            // Hide all methods initially
            shippingRadios.forEach(radio => {
                const label = radio.closest('label');
                if (label) {
                    label.style.display = 'none';
                    radio.disabled = true;
                }
            });

            const cartTags = await getCartProductTags();
            console.log('🏷️ Cart tags:', Array.from(cartTags));

            // Define allowed shipping based on Coldcart tags
            let allowedMethods = ['Flat Rate Shipping'];
let customerTagsData = window.currentCustomer.tags.map(t => t.toLowerCase());

    // Find which customer group tag matches
    const foundGroupTagDataForFreeShipping = Object.keys(CUSTOMER_GROUPS)
        .find(tag => customerTagsData.includes('b2b-pet-supplies-plus'));
        if(foundGroupTagDataForFreeShipping) {
            allowedMethods = ['Free Shipping'];
        } else {

            if (cartTags.has('coldcart-dry') && cartTags.has('coldcart-frozen')) {
                allowedMethods = ['Standard Dry & Frozen Shipping'];
            } else if (cartTags.has('coldcart-dry')) {
                allowedMethods = ['Standard Dry Shipping'];
            } else if (cartTags.has('coldcart-frozen')) {
                allowedMethods = ['Standard Frozen Shipping'];
            }
        }

            const allowedSet = allowedMethods ? new Set(allowedMethods.map(m => m.toLowerCase())) : null;
            let firstVisible = null;
            let visibleCount = 0;

            shippingRadios.forEach(radio => {
                const label = radio.closest('label');
                if (!label) return;

                const methodNameEl = label.querySelector('p.break-words') || label.querySelector('p');
                const methodName = methodNameEl?.textContent.trim() || '';
                const priceEl = label.querySelector('em.not-italic');
                const price = priceEl?.textContent.trim() || '';

                let isAllowed = allowedSet ? allowedSet.has(methodName.toLowerCase()) : true;

                if (isAllowed) {
                    label.style.display = '';
                    radio.disabled = false;
                    visibleCount++;
                    if (!firstVisible) firstVisible = radio;
                    console.log(`✅ SHOW: ${methodName} ${price}`);
                } else {
                    label.style.display = 'none';
                    radio.disabled = true;
                    if (radio.checked) radio.checked = false;
                    console.log(`❌ HIDE: ${methodName} ${price}`);
                }
            });

            // Handle no visible methods
            if (visibleCount === 0) {
                console.warn('⚠️ NO SHIPPING METHODS AVAILABLE AFTER FILTERING');
                //showNoMethodsMessage();
            } else {
                //hideNoMethodsMessage();

                // Auto-select first visible option
                if (firstVisible && !Array.from(shippingRadios).some(r => r.checked && r.closest('label').style.display !== 'none')) {
                    firstVisible.checked = true;
                    firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }

            console.log(`✅ ⏹️ FILTERING COMPLETE! (${visibleCount} methods visible)\n`);
            hideLoadingOverlay();
            // Setup listeners
            setupChangeListeners(shippingRadios);

        } catch (error) {
            console.error('❌ Error during filtering:', error);
        } finally {
            // ALWAYS hide overlay and reset flag after delay
            setTimeout(() => {
                hideLoadingOverlay();
                isFiltering = false;
                console.log('🔓 Filtering flag released');
            }, 500);
        }
    }

    // ------------------------------
    // Setup change listeners
    // ------------------------------
    function setupChangeListeners(radios) {
        radios.forEach(radio => {
            if (!radio || !radio.parentNode) return;

            try {
                const newRadio = radio.cloneNode(true);
                if (radio.parentNode) {
                    radio.parentNode.replaceChild(newRadio, radio);

                    newRadio.addEventListener('change', function () {
                        const label = this.closest('label');
                        const methodName = (label?.querySelector('p.break-words') || label?.querySelector('p'))?.textContent.trim() || 'Unknown';
                        console.log('%c🚚 Shipping Method Changed', 'background: blue; color: white; padding: 5px;');
                        console.log('Selected:', methodName);
                    });
                }
            } catch (err) {
                console.warn('Could not clone radio, adding listener directly');
                radio.addEventListener('change', function () {
                    const label = this.closest('label');
                    const methodName = (label?.querySelector('p.break-words') || label?.querySelector('p'))?.textContent.trim() || 'Unknown';
                    console.log('%c🚚 Shipping Method Changed', 'background: blue; color: white; padding: 5px;');
                    console.log('Selected:', methodName);
                });
            }
        });
    }

    // ------------------------------
    // Setup MutationObserver - FIXED TO PREVENT LOOPS
    // ------------------------------
    function observeShippingStepChanges() {
        const sparkDrawer = document.querySelector('spark-drawer');
        if (!sparkDrawer?.shadowRoot) {
            setTimeout(observeShippingStepChanges, 500);
            return;
        }

        console.log('👀 Setting up shipping step observer...');

        let mutationTimeout = null;
        let lastMutationTime = 0;

        const observer = new MutationObserver((mutations) => {
            const now = Date.now();

            // Ignore mutations that happen during filtering
            if (isFiltering) {
                return;
            }

            // Debounce: only process if 500ms have passed since last mutation
            if (now - lastMutationTime < 500) {
                clearTimeout(mutationTimeout);
            }

            lastMutationTime = now;

            // Check if this is a significant mutation (new shipping methods added)
            const hasNewShippingMethods = mutations.some(mutation => {
                if (mutation.type === 'childList') {
                    const addedNodes = Array.from(mutation.addedNodes);
                    return addedNodes.some(node => {
                        if (node.nodeType === 1) { // Element node
                            return node.matches?.('input[name="shipping-method"]') ||
                                node.querySelector?.('input[name="shipping-method"]');
                        }
                        return false;
                    });
                }
                return false;
            });

            // Only trigger detection for significant changes
            if (hasNewShippingMethods) {
                showLoadingOverlay();
                mutationTimeout = setTimeout(() => {
                    detectUIChanges();
                }, 500);
            }
        });

        observer.observe(sparkDrawer.shadowRoot, {
            childList: true,
            subtree: true,
            attributes: false // Don't watch attribute changes to avoid our own style changes
        });

        console.log('✅ Shipping step observer active');
    }

    // ------------------------------
    // Start monitoring - MINIMAL INTERVALS
    // ------------------------------
    function startMonitoring() {
        console.log('🔄 Monitoring for spark-drawer and shipping methods...');

        observeShippingStepChanges();

        // Rapid initial check to hide methods ASAP
        const rapidCheck = setInterval(() => {
            if (hideAllShippingMethods() && !hasAppliedInitialHide) {
                hasAppliedInitialHide = true;
                console.log('🔒 Initial hide applied');
            }
        }, 100);

        setTimeout(() => clearInterval(rapidCheck), 100);

        // ONLY use fallback check sparingly - MutationObserver should handle most cases
        setInterval(() => {
            // Only check if not currently filtering
            if (!isFiltering) {
                performUICheck();
            }
        }, 5000); // Increased from 3s to 5s - less aggressive
    }
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            //console.log('User switched away from the tab 💤');
        } else {
            filterShippingMethodsByTags(true);
            runMMQCheck_NoCache();
        }
    });
    // ------------------------------
    // Minimum Order Value Check (Frozen & Dry)
    // ------------------------------
    async function checkMinimumOrderValue() {
        try {
            const items = await getCartItems();
            if (!items || !items.length) {
                removeMMQMessage();
                enableCheckoutButton();
                return;
            }

            let frozenTotal = 0;
            let dryTotal = 0;
            const frozenProducts = [];
            const dryProducts = [];
            const { frozen: MIN_FROZEN, dry: MIN_DRY } = getCustomerMOQ();

            //  const MIN_FROZEN = 150;
            //  const MIN_DRY = 150;

            for (const item of items) {
                const tags = await getProductTags(item.parentExternalId);
                const itemTotal = item.lineTotal?.gross || 0;

                if (tags.some(tag => tag.toLowerCase().includes("coldcart-frozen"))) {
                    frozenTotal += itemTotal;
                    frozenProducts.push(item.name);
                }

                if (tags.some(tag => tag.toLowerCase().includes("coldcart-dry"))) {
                    dryTotal += itemTotal;
                    dryProducts.push(item.name);
                }
            }

            let message = "";
            let violation = false;

            if (frozenProducts.length && frozenTotal < MIN_FROZEN) {
                violation = true;
                message += `🧊 Frozen items require a minimum order of $${MIN_FROZEN}.\nYou currently have $${frozenTotal.toFixed(2)}.\nAffected Products: ${frozenProducts.join(", ")}\n\n`;
            }

            if (dryProducts.length && dryTotal < MIN_DRY) {
                violation = true;
                message += `🪵 Dry items require a minimum order of $${MIN_DRY}.\nYou currently have $${dryTotal.toFixed(2)}.\nAffected Products: ${dryProducts.join(", ")}\n`;
            }

            if (violation) {
                console.warn("⚠️ MMQ Restriction:", message);
                showMMQMessage(message);
                disableCheckoutButton();
            } else {
                removeMMQMessage();
                enableCheckoutButton();
            }
        } catch (err) {
            console.error("❌ Error in checkMinimumOrderValue:", err);
            enableCheckoutButton(); // fail-safe
        }
    }

    // ------------------------------
    // Inject MMQ warning above Checkout button
    // ------------------------------
    function showMMQMessage(message) {
        const checkoutSpan = findCheckoutSpan();
        if (!checkoutSpan) return;

        removeMMQMessage();

        const warningBox = document.createElement("div");
        warningBox.className = "mmq-warning-box";
        warningBox.style.cssText = `
        background: #fff8f0;
        border: 1px solid #f97316;
        padding: 12px 16px;
        border-radius: 8px;
        margin-bottom: 10px;
        color: #9a3412;
        font-size: 14px;
        line-height: 1.5;
        font-weight: 500;
        white-space: pre-line;
    `;
        warningBox.textContent = `⚠️ This cart contains items that have a Minimum Order Value requirement.\n\n${message}`;

        const parent = checkoutSpan.closest("button, div")?.parentElement;
        if (parent) {
            parent.insertBefore(warningBox, parent.firstChild);
        }
    }

    // ------------------------------
    // Remove MMQ message
    // ------------------------------
    function removeMMQMessage() {
        document.querySelectorAll(".mmq-warning-box").forEach(el => el.remove());
    }

    // ------------------------------
    // Disable and enable Checkout button
    // ------------------------------
    function disableCheckoutButton() {
        const checkoutSpan = findCheckoutSpan();
        console.log('chckout span',findCheckoutSpan);
        if (!checkoutSpan) return;

        const btn = checkoutSpan.closest("button");
        if (btn) {
            btn.disabled = true;
            btn.style.opacity = "0.6";
            btn.style.cursor = "not-allowed";
        }
    }

    function enableCheckoutButton() {
        const checkoutSpan = findCheckoutSpan();
        if (!checkoutSpan) return;

        const btn = checkoutSpan.closest("button");
        if (btn) {
            btn.disabled = false;
            btn.style.opacity = "1";
            btn.style.cursor = "pointer";
        }
    }

    // ------------------------------
    // Utility: Find Checkout span/button
    // ------------------------------
    function findCheckoutSpan2() {
        // Most Spark checkout buttons use <span>Checkout</span> inside a button
        const spans = Array.from(document.querySelectorAll("span"));
        return spans.find(sp => sp.textContent.trim().toLowerCase() === "checkout") || null;
    }

    // ------------------------------
    // Attach SparkLayer analytics events
    // ------------------------------
    window.sparkOptions = window.sparkOptions || {};
    window.sparkOptions.analytics = window.sparkOptions.analytics || { providers: [] };

    window.sparkOptions.analytics.providers.push({
        handler(eventName) {
            console.log(`📡 SparkLayer Event: ${eventName}`);

            if (['shippingUpdate', 'beginCheckout', 'finalStageCheckout', 'cartUpdate'].includes(eventName)) {
                console.log(`Event detected: ${eventName} - forcing cart refresh`);
                shippingDetected = false;
                hasAppliedInitialHide = false;
                cartStateCache = null;
                lastCartHash = null;
                lastFilteredHash = null;

                // Wait for filtering to complete if in progress
                setTimeout(() => {
                    if (!isFiltering) {
                        filterShippingMethodsByTags(true);
                    }
                }, 300);
            }

            if (['checkoutStepChange', 'shippingMethodSelected'].includes(eventName)) {
                console.log(`Navigation event detected: ${eventName}`);
                hasAppliedInitialHide = false;
                setTimeout(() => {
                    // hideAllShippingMethods();
                    filterShippingMethodsByTags(true);
                }, 200);
            }
        },
        events: {
            shippingUpdate: true,
            beginCheckout: true,
            finalStageCheckout: true,
            cartUpdate: true,
            checkoutStepChange: true,
            shippingMethodSelected: true
        }
    });

    startMonitoring();
})();


// =============================
// MMQ + Network Idle Tracker (Integrated from mmq.js)
// =============================

// === Independent Minimum Order Value Checker (No Cache) ===
// Paste & run directly in console after your SparkLayer script is loaded.
// Global network tracker
(function () {
    window.__pendingRequests = 0;

    // ---- Intercept Fetch ----
    const origFetch = window.fetch;
    window.fetch = async function (...args) {
        window.__pendingRequests++;
        try {
            return await origFetch.apply(this, args);
        } finally {
            window.__pendingRequests--;
        }
    };

    // ---- Intercept XHR ----
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (...args) {
        this.addEventListener('loadstart', () => window.__pendingRequests++);
        this.addEventListener('loadend', () => window.__pendingRequests--);
        return origOpen.apply(this, args);
    };
})();
async function waitForNetworkIdle(timeout = 10000, interval = 100) {
    const start = Date.now();
    while (window.__pendingRequests > 0) {
        if (Date.now() - start > timeout) {
            console.warn("Network still busy, proceeding anyway...");
            break;
        }
        await new Promise((res) => setTimeout(res, interval));
    }
}

function getCustomerMOQ() {
    
    // Default MOQ if no matching tag found
    const defaultMOQ = { frozen: 150, dry: 150 };

    // Ensure customer info is available
    if (!window.currentCustomer || !window.currentCustomer.tags) {
        console.warn("No customer logged in or tags missing — using default MOQ");
        return defaultMOQ;
    }

    const customerTags = window.currentCustomer.tags.map(t => t.toLowerCase());

    // Find which customer group tag matches
    const foundGroupTag = Object.keys(CUSTOMER_GROUPS)
        .find(tag => customerTags.includes(tag));

    if (!foundGroupTag) {
        console.warn("No matching customer group found — using default MOQ");
        return defaultMOQ;
    }

    // Extract frozen/dry MOQs from matching group
    const frozenMOQ = CUSTOMER_GROUPS[foundGroupTag]
        .find(i => i.tag === "coldcart-frozen")?.moq ?? defaultMOQ.frozen;

    const dryMOQ = CUSTOMER_GROUPS[foundGroupTag]
        .find(i => i.tag === "coldcart-dry")?.moq ?? defaultMOQ.dry;

    console.log(`Matched group: ${foundGroupTag}`, { frozenMOQ, dryMOQ });

    return { frozen: frozenMOQ, dry: dryMOQ };
}
async function runMMQCheck_NoCache() {
    showShadowLoader();
    console.log("Running MMQ (Min Order Value) Check...", "background:#000; color:#f97316; padding:4px;");
    await waitForNetworkIdle();

    console.log("Network idle. Proceeding with MMQ check...", "background:#022; color:#4ade80; padding:4px;");

    const productTagCache = {};
    let cartStateCache = null;
    let lastCartHash = null;
    let lastFilteredHash = null;
    let isFiltering = false;
    let hasAppliedInitialHide = false;
    let lastShippingRadioCount = 0;
    let shippingStepVisible = false;
    let debounceTimer = null;
    let shippingDetected = false;

    const SHOPIFY_STORE = "bossnationbrand.myshopify.com";
    const STOREFRONT_TOKEN = "981d248c9420e05cd5aaa55e466e594a";
    if (typeof getCartItems !== "function") {
        console.error("getCartItems() not found. Make sure Spark script loaded.");
        return;
    }
    if (typeof getProductTags !== "function") {
        console.error("getProductTags() not found. Make sure Spark script loaded.");
        return;
    }

    try {
        const items = await getCartItems();
        if (!items?.length) {
            publishFrozenCartState(false, false, 0, true);
            console.warn("Cart empty — nothing to check.");
            removeMMQMessage();
            enableCheckoutButton();
            hideShadowLoader();
            return;
        }

        let frozenTotal = 0, dryTotal = 0;
        const frozenProducts = [], dryProducts = [];
        const { frozen: MIN_FROZEN, dry: MIN_DRY } = getCustomerMOQ();

        //const MIN_FROZEN = 150, MIN_DRY = 150;

        for (const item of items) {
            const productId = item.parentExternalId;
            if (!productId) continue;

            // Fresh fetch — ignore productTagCache completely
            const tags = await getProductTags(productId);
            const tagList = (tags || []).map(t => t.toLowerCase());
            const total = item.lineTotal?.gross || 0;
            console.log('tagList', tagList);
            if (tagList.includes("coldcart-frozen")) {

                frozenTotal += total;
                frozenProducts.push(item.name);
            }
            if (tagList.includes("coldcart-dry")) {
                console.log(item.name + '-', total)
                dryTotal += total;
                dryProducts.push(item.name);
            }
        }

        console.log("Frozen Total:", frozenTotal, " Dry Totals:", dryTotal);

        let message = "";
        let violation = false;


        message = `
<div style="
    background:#fff8e1;
    border:1px solid #f5d07c;
    border-radius:6px;
    padding:8px 12px;
    margin:6px 0;
    font-size:13px;
    color:#4a3b00;
">
    <b style="
    display: flex;
    gap: 10px;
"><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="#ea0a2a">
<path d="M12 16.99V17M12 7V14M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg> This cart contains items with a Minimum Order Value requirement.</b>
</div>
`;

        const boxStyle = `
    display:flex;
    flex-direction:column;
    gap:2px;
    background:#fff;
    border-radius:6px;
    padding:8px 10px;
    font-size:13px;
    color:#333;
    border:1px solid #eee;
`;

        let itemBoxes = [];

if (frozenProducts.length && frozenTotal < MIN_FROZEN) {
            violation = true;
            itemBoxes.push(`
        <div style="${boxStyle}; background:#fff4f4; border-color:#f5b5b5;">
            <div style="display:flex; justify-content:space-between; align-items:center;">
                <span><b>Frozen Items</b></span>
                <span>Need $${MIN_FROZEN.toFixed(2)}</span>
            </div>
            <div style="display:flex; justify-content:space-between; align-items:center;gap:30px">
                <span>Now: $${frozenTotal.toFixed(2)}</span>
                <small style="opacity:0.8;display: flex;flex-wrap: wrap;width: 240px;justify-content: flex-end;">${frozenProducts.join(", ")}</small>
            </div>
        </div>
    `);
        }

        if (dryProducts.length && dryTotal < MIN_DRY) {
            violation = true;
            itemBoxes.push(`
        <div style="${boxStyle}; background:#fff8ef; border-color:#f5c58c;">
            <div style="display:flex; justify-content:space-between; align-items:center;">
                <span><b>Dry Items</b></span>
                <span>Need $${MIN_DRY.toFixed(2)}</span>
            </div>
            <div style="display:flex; justify-content:space-between; align-items:center;gap:30px">
                <span>Now: $${dryTotal.toFixed(2)}</span>
                <small style="opacity:0.8;display: flex;flex-wrap: wrap;width: 240px;justify-content: flex-end;">${dryProducts.join(", ")}</small>
            </div>
        </div>
    `);
        }
        if (itemBoxes.length) {
            message += `
    <div style="
        display:flex;
        flex-wrap:wrap;
        gap:8px;
        margin-top:6px;
    ">
        ${itemBoxes.join("")}
    </div>
    `;
        }



        if (violation) {
            console.warn("MMQ Restriction Triggered..\n" + message);
             disableCheckoutButton();
            showMMQMessage(message);
           
        } else {
            console.log("All MMQ requirements satisfied!", "color:green;font-weight:bold;");
            enableCheckoutButton();
            removeMMQMessage();
            
        }
        publishFrozenCartState(frozenProducts.length > 0, dryProducts.length > 0, frozenProducts.length, true);
 console.log('after recechk', violation);
    } catch (err) {
        console.error("Error while checking MMQ:", err);
        publishFrozenCartState(false, false, 0, false);
    }
    async function getProductTags(productId) {
        if (productTagCache[productId]) {
            return productTagCache[productId];
        }

        const query = `
      {
        product(id: "gid://shopify/Product/${productId}") {
          tags
        }
      }
    `;
        const res = await fetch(`https://${SHOPIFY_STORE}/api/2025-07/graphql.json`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
            },
            body: JSON.stringify({ query }),
        });
        const data = await res.json();
        const tags = data.data.product?.tags || [];

        productTagCache[productId] = tags;
        return tags;
    }
    async function getCartItems() {
        try {
            if (!window.spark?.getCart) return [];
            const res = await window.spark.getCart();
            console.log('Cart', res);
            return res.items;
        } catch (err) {
            console.error('Error fetching cart:', err);
            return [];
        }
    }
    // === Helper Functions ===

    function findCheckoutSpan3() {
        const sparkDrawer = document.querySelector('spark-drawer');

        return Array.from(sparkDrawer.shadowRoot.querySelectorAll("span"))
            .find(sp => sp.textContent.trim().toLowerCase() === "checkout");
    }
   function findCheckoutSpan() {
    // First, try to find the spark-drawer element
    const sparkDrawer = document.querySelector("spark-drawer");
    
    if (!sparkDrawer || !sparkDrawer.shadowRoot) {
        console.log('no spark');
        return null;
    }
    
    // Search within the shadow root
    const elements = Array.from(sparkDrawer.shadowRoot.querySelectorAll("span, button, a"));
    console.log(elements);
    
    // First, try to find "continue" (case-insensitive)
    const continueElement = elements.find(el => 
        el.textContent.trim().toLowerCase().includes("continue")
    );
    console.log(continueElement);
    if (continueElement) return continueElement;
    
    // Second, try to find "complete order" (case-insensitive)
    const completeOrderElement = elements.find(el => 
        el.textContent.trim().toLowerCase().startsWith("complete order")
    );
    console.log(completeOrderElement);
    if (completeOrderElement) return completeOrderElement;
    
    // If not found, look for "checkout"
    const checkoutElement = elements.find(el => 
        el.textContent.trim().toLowerCase().includes("checkout")
    );
    return checkoutElement || null;
}

    function disableCheckoutButton() {
        console.log('Inside disabes');
        const span = findCheckoutSpan();
        console.log('spn', span);
        if (!span) return;
        const btn = span.parentElement.closest("button");
        if (span) {
            span.disabled = true;
            span.style.opacity = "0.6";
            span.style.cursor = "not-allowed";
        }
    }

    function enableCheckoutButton() {
        const span = findCheckoutSpan();
        if (!span) return;
        const btn = span.parentElement.closest("button");
        if (span) {
            span.disabled = false;
            span.style.opacity = "1";
            span.style.cursor = "pointer";
        }
    }

    function showMMQMessage(message) {
        const span = findCheckoutSpan();
        if (!span) return;

        removeMMQMessage();

        const box = document.createElement("div");
        box.className = "mmq-warning-box";
        box.style.cssText = `
            background:#fff8f0;
            border:1px solid #f97316;
            border-radius:8px;
            padding:12px 16px;
            margin-bottom:10px;
            color:#9a3412;
            font-size:14px;
            line-height:1.4;
            font-weight:500;
        `;
        box.innerHTML = `${message}`;

        const parent = span.closest("button, div")?.parentElement.parentElement;
        if (parent) parent.insertBefore(box, parent.firstChild);
    }

    function removeMMQMessage() {
        const sparkDrawer = document.querySelector('spark-drawer');

        sparkDrawer.shadowRoot.querySelectorAll(".mmq-warning-box").forEach(el => el.remove());
    }

    hideShadowLoader();
}
function initButtonTrack() {
    const sparkDrawer = document.querySelector('spark-drawer');

    if (sparkDrawer && sparkDrawer.shadowRoot) {
        sparkDrawer.shadowRoot.addEventListener('click', onShadowButtonClick);
        console.log('✅ Button tracking attached');
    } else {
        console.warn('⚠️ sparkDrawer or shadowRoot not found yet');
    }
}

function onShadowButtonClick(event) {
    const button = event.target.closest('button');
    if (button) {
        console.log('Button clicked inside shadowRoot:', button);
        setTimeout(() => {
            runMMQCheck_NoCache();
        }, 1000);
    }
}
function initInputTrack() {
    const sparkDrawer = document.querySelector('spark-drawer');

    if (sparkDrawer && sparkDrawer.shadowRoot) {
        // Listen for Enter key
        sparkDrawer.shadowRoot.addEventListener('keydown', onShadowInputEvent, true);
        // Listen for blur (when input loses focus)
        sparkDrawer.shadowRoot.addEventListener('blur', onShadowInputEvent, true);

        console.log('✅ Input tracking (Enter + Blur) attached inside shadowRoot');
    } else {
        console.warn('⚠️ sparkDrawer or shadowRoot not found yet');
    }
}

function onShadowInputEvent(event) {
    const input = event.target.closest('input');
    if (!input) return;

    // Trigger when Enter pressed OR when focus leaves
    if (event.type === 'keydown' && event.key === 'Enter') {
        console.log('⏎ Enter pressed in input:', input);
        triggerMMQAfterDelay();
    }

    if (event.type === 'blur') {
        console.log('👆 Input lost focus:', input);
        triggerMMQAfterDelay();
    }
}

function triggerMMQAfterDelay() {
    clearTimeout(window.__mmqTimer);
    window.__mmqTimer = setTimeout(async () => {
        await runMMQCheck_NoCache();
    }, 1000);
}

const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.tagName.toLowerCase() === 'spark-drawer') {
                console.log('✅ spark-drawer inserted:', node);
                setTimeout(() => {
                    runMMQCheck_NoCache();
                }, 1000);
                initButtonTrack();
                initInputTrack();
            }
        });

        mutation.removedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.tagName.toLowerCase() === 'spark-drawer') {
                console.log('❌ spark-drawer removed:', node);
                node.shadowRoot?.removeEventListener('click', onShadowButtonClick);
                node.shadowRoot?.removeEventListener('change', onShadowInputEvent);
                node.shadowRoot?.removeEventListener('keydown', onShadowInputEvent, true);
                node.shadowRoot?.removeEventListener('blur', onShadowInputEvent, true);
            }
        });
    }
});

observer.observe(document.body, { childList: true, subtree: true });

// ▶️ Run it manually

function findMainTag() {
    const sparkDrawer = document.querySelector('spark-drawer');
    if (!sparkDrawer || !sparkDrawer.shadowRoot) return null;

    const mainTag = sparkDrawer.shadowRoot.querySelector('main');
    return mainTag || null;
}
function showShadowLoader() {
    const sparkDrawer = document.querySelector('spark-drawer');
    if (!sparkDrawer || !sparkDrawer.shadowRoot) {
        console.warn('sparkDrawer or shadowRoot not found');
        return;
    }

    // Function to recursively search for text in shadow DOM and nested shadow DOMs
    function searchTextInShadow(root) {
        let textContent = '';
        
        function traverse(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                textContent += node.textContent;
            } else if (node.shadowRoot) {
                traverse(node.shadowRoot);
            }
            
            if (node.childNodes) {
                node.childNodes.forEach(child => traverse(child));
            }
        }
        
        traverse(root);
        return textContent;
    }

    // Get all text content including nested shadow DOMs
    const shadowContent = searchTextInShadow(sparkDrawer.shadowRoot);
    
    console.log('Shadow DOM content:', shadowContent); // Debug log
    
    const hasAddress = /address/i.test(shadowContent);
    
    console.log( 'Has Address:', hasAddress); // Debug log
    
    

    if (hasAddress) {
        console.log('Address text found in shadow DOM - loader not shown');
        return;
    }

    // Avoid duplicates
    if (sparkDrawer.shadowRoot.querySelector('#mmq-loader')) return;

    const overlay = document.createElement('div');
    overlay.id = 'mmq-loader';
    overlay.innerHTML = `
    <div class="loader-spinner"></div>
  `;
    Object.assign(overlay.style, {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, 0.35)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '9999',
    });

    const spinner = overlay.querySelector('.loader-spinner');
    Object.assign(spinner.style, {
        width: '48px',
        height: '48px',
        border: '5px solid #fff',
        borderTop: '5px solid #ea0a2a',
        borderRadius: '50%',
        animation: 'mmqSpin 1s linear infinite',
    });

    // Inject keyframes for spinner
    const style = document.createElement('style');
    style.textContent = `
    @keyframes mmqSpin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
  `;
    overlay.appendChild(style);
    mainParent = findMainTag();
    mainParent.appendChild(overlay);
    console.log('Loader shown inside shadowRoot');
}

function showShadowLoader2() {
    const sparkDrawer = document.querySelector('spark-drawer');
    if (!sparkDrawer || !sparkDrawer.shadowRoot) {
        console.warn('sparkDrawer or shadowRoot not found');
        return;
    }

    // Avoid duplicates
    if (sparkDrawer.shadowRoot.querySelector('#mmq-loader')) return;

    const overlay = document.createElement('div');
    overlay.id = 'mmq-loader';
    overlay.innerHTML = `
    <div class="loader-spinner"></div>
  `;
    Object.assign(overlay.style, {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, 0.35)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '9999',
    });

    const spinner = overlay.querySelector('.loader-spinner');
    Object.assign(spinner.style, {
        width: '48px',
        height: '48px',
        border: '5px solid #fff',
        borderTop: '5px solid #ea0a2a',
        borderRadius: '50%',
        animation: 'mmqSpin 1s linear infinite',
    });

    // Inject keyframes for spinner
    const style = document.createElement('style');
    style.textContent = `
    @keyframes mmqSpin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
  `;
    overlay.appendChild(style);
    mainParent = findMainTag();
    mainParent.appendChild(overlay);
    console.log(' Loader shown inside shadowRoot');
}

function hideShadowLoader() {
    const sparkDrawer = document.querySelector('spark-drawer');
    const loader = sparkDrawer?.shadowRoot?.querySelector('#mmq-loader');
    if (loader) {
        loader.remove();
        console.log('🟢 Loader hidden');
    }
}

// Hide Bundle for b2b
(function() {
  const restrictedTags = ["b2b", "wholster_customer"];
  let intervalCount = 0;
  const maxChecks = 20; // safety limit (20 seconds)

  const checkAndHide = () => {
    const customer = window.currentCustomer;
    const bundle = document.querySelector("#gbbBundle");

    if (bundle && customer && Array.isArray(customer.tags)) {
      const customerTags = customer.tags.map(t => t.toLowerCase());
      const isRestricted = restrictedTags.some(tag => customerTags.includes(tag));

      if (isRestricted) {
        bundle.innerHTML = `
          <div style="
            text-align: center;
            padding: 50px 20px;
            border: 2px dashed #d1d5db;
            border-radius: 16px;
            background: #f9fafb;
            max-width: 600px;
            margin: 40px auto;
            box-shadow: 0 2px 6px rgba(0,0,0,0.05);
            animation: fadeIn 0.5s ease forwards;
          ">
            <h2 style="font-size: 1.5rem; font-weight: 600; color: #111827; margin-bottom: 10px;">
              Bundle Builder Unavailable
            </h2>
            <p style="font-size: 1rem; color: #4b5563;">
              This feature is not available for <strong>B2B customers</strong> at the moment.<br>
            </p>
            <a href="/collections/all" style="
              display: inline-block;
              margin-top: 20px;
              background-color: #111827;
              color: white;
              padding: 10px 20px;
              border-radius: 8px;
              text-decoration: none;
              font-weight: 500;
              transition: background 0.3s;
            " onmouseover="this.style.backgroundColor='#1f2937'"
               onmouseout="this.style.backgroundColor='#111827'">
              Browse Products
            </a>
          </div>
        `;
      }

      // Stop checking once found
      clearInterval(checkInterval);
    }

    // Safety stop if it never finds the element
    if (++intervalCount > maxChecks) {
      clearInterval(checkInterval);
    }
  };

  const checkInterval = setInterval(checkAndHide, 1000);
})();

// Make Onetime as default 
    // Only run on product pages
    // Only run on product pages



// Sccript to override subis code
(function () {
    return;
  // config
  const DELAY_AFTER_CLICK = 180; // wait for subify to update, ms
  const DEBOUNCE_MUTATION_MS = 120;

  // state
  let pendingSync = false;
  let pendingPrice = null;
  let pendingVisibility = null; // 'subscription' | 'oneTime' | null
  let mutationTimer = null;

  // helpers
  const qs = sel => document.querySelector(sel);
  const qsa = sel => Array.from(document.querySelectorAll(sel));

  function getDisplayedSalePrice() {
    return qs('.price__container .price-item--sale')?.textContent?.trim()
      || qs('.price__container .price-item--regular')?.textContent?.trim()
      || null;
  }

  function syncOneTimePrice2(price) {
    if (!price) return;
    const oneTimePriceEl = qs('#subify-widget-one-time-purchase-text')
      ?.closest('.subify-choice-box-wrapper')
      ?.querySelector('.subify-choice-price');
    if (!oneTimePriceEl) return;
    // Apply inside requestAnimationFrame to be as "non-blocking" and safe as possible
    requestAnimationFrame(() => {
      oneTimePriceEl.innerText = price;
      console.log('✅ Synced one-time price →', price);
    });
  }
function syncOneTimePrice() {
  const priceContainer = document.querySelector('.price__container');
  const salePriceEl = priceContainer?.querySelector('.price-item--sale');
  const regularPriceEl = priceContainer?.querySelector('.price-item--regular');
  const oneTimePriceEl = document.querySelector('.subify-choice-price');

  if (!oneTimePriceEl) return;

  const newPrice = (salePriceEl?.textContent || regularPriceEl?.textContent || '').trim();
  if (newPrice && oneTimePriceEl.textContent.trim() !== newPrice) {
    oneTimePriceEl.textContent = newPrice;
    console.log('✅ Synced One-time purchase price →', newPrice);
  }
}

// Run once immediately
syncOneTimePrice();

// Also re-sync if the price container updates dynamically
const priceObserver = new MutationObserver(syncOneTimePrice);
const priceContainer = document.querySelector('.price__container');
if (priceContainer) {
  priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
}

  function toggleVisibility(showSubscription) {
    const subifyPriceWrapper = qs('.subify-product-price-wrapper');
    const priceContainer = qs('.price__container');

    if (showSubscription) {
      if (subifyPriceWrapper) subifyPriceWrapper.classList.remove('hidden');
      if (priceContainer) {
        priceContainer.classList.add('hidden');
        priceContainer.style.display = 'none';
      }
    } else {
      if (priceContainer) {
        priceContainer.classList.remove('hidden');
        priceContainer.style.display = 'block';
      }
      if (subifyPriceWrapper) subifyPriceWrapper.classList.add('hidden');
    }
  }

  function applyPendingNow() {
    // If there's a specific pendingVisibility, respect that; otherwise derive from active class
    if (pendingVisibility === 'subscription') {
      toggleVisibility(true);
    } else if (pendingVisibility === 'oneTime') {
      toggleVisibility(false);
    } else {
      // Derive from .active state
      const activeBox = qs('.subify-choice-box-wrapper.active');
      const isSubscriptionActive = Boolean(activeBox?.querySelector('#subify-widget-subscription-text'));
      toggleVisibility(Boolean(isSubscriptionActive));
    }

    // Sync price if requested
    if (pendingSync) {
      const sale = pendingPrice || getDisplayedSalePrice();
      if (sale) syncOneTimePrice(sale);
      pendingSync = false;
      pendingPrice = null;
    }

    // clear pendingVisibility after apply
    pendingVisibility = null;
  }

  // Debounced handler used by the MutationObserver to reapply state after Subify re-renders
  function scheduleReapplyFromMutations() {
    if (mutationTimer) clearTimeout(mutationTimer);
    mutationTimer = setTimeout(() => {
      applyPendingNow();
      mutationTimer = null;
    }, DEBOUNCE_MUTATION_MS);
  }

  // Click listeners (text spans already working for you; wrapper clicks handled too)
  document.addEventListener('click', function (e) {
    const clickedSubscriptionText = e.target.closest('#subify-widget-subscription-text');
    const clickedOneTimeText = e.target.closest('#subify-widget-one-time-purchase-text');
    const clickedWrapper = e.target.closest('.subify-choice-box-wrapper');

    // If wrapper clicked (not the inner span), emulate click on the inner text so Subify's handlers run
    if (clickedWrapper && !clickedSubscriptionText && !clickedOneTimeText) {
      const inner = clickedWrapper.querySelector('#subify-widget-subscription-text, #subify-widget-one-time-purchase-text');
      if (inner) inner.click();
      pendingSync = true;
      setTimeout(() => {
        applyPendingNow();
      }, DELAY_AFTER_CLICK);
      // Let the rest flow through — we still check below for relevant clicks.
    }

    // If subscription clicked
    if (clickedSubscriptionText) {
      // mark pending visibility and reapply after a short delay (Subify updates first)
      pendingVisibility = 'subscription';
      pendingSync = true;
      setTimeout(() => {
        applyPendingNow();
      }, DELAY_AFTER_CLICK);
    }

    // If one-time clicked
    if (clickedOneTimeText) {
      pendingVisibility = 'oneTime';
      // capture sale price immediately (may be null if not rendered yet)
      pendingPrice = getDisplayedSalePrice();
      // request a sync and reapply after Subify's internal updates
      pendingSync = true;
      setTimeout(() => {
        applyPendingNow();
      }, DELAY_AFTER_CLICK);
    }
  });

  // MutationObserver to reapply state if Subify re-renders the price/choice DOM
  const observer = new MutationObserver((mutations) => {
    // Quick filter: only care about changes that touch price container or choice wrappers
    const relevant = mutations.some(m => {
      const nodes = [...m.addedNodes, ...m.removedNodes];
      return nodes.some(n => {
        if (!(n instanceof Element)) return false;
        return n.matches?.('.price__container, .subify-product-price-wrapper, .subify-choice-box-wrapper') ||
               n.querySelector?.('.price__container, .subify-product-price-wrapper, .subify-choice-box-wrapper');
      });
    });
    if (relevant) scheduleReapplyFromMutations();
  });

  observer.observe(document.body, { childList: true, subtree: true, characterData: false });

  // initial sync on load (if subify already set an active)
  window.addEventListener('DOMContentLoaded', function () {
    // set pending based on current active state
    const activeBox = qs('.subify-choice-box-wrapper.active');
    const isSubscriptionActive = Boolean(activeBox?.querySelector('#subify-widget-subscription-text'));
    pendingVisibility = isSubscriptionActive ? 'subscription' : 'oneTime';
    if (!isSubscriptionActive) {
      pendingSync = true;
      pendingPrice = getDisplayedSalePrice();
    }
    // Apply after a short delay to let the widget finish any immediate initialization
    setTimeout(() => applyPendingNow(), 120);
  });

  // cleanup helper (optional)
  // window.addEventListener('beforeunload', () => observer.disconnect());
})();

function syncOneTimePrice() {
  const priceContainer = document.querySelector('.price__container');
  const salePriceEl = priceContainer?.querySelector('.price-item--sale');
  const regularPriceEl = priceContainer?.querySelector('.price-item--regular');
  const oneTimePriceEl = document.querySelector('.subify-choice-price');

  if (!oneTimePriceEl) return;

  const newPrice = (
    salePriceEl?.textContent ||
    regularPriceEl?.textContent ||
    ''
  ).trim();

  if (newPrice && oneTimePriceEl.textContent.trim() !== newPrice) {
    oneTimePriceEl.textContent = newPrice;
    console.log('✅ Synced One-time purchase price →', newPrice);
  }
}

// Run after page fully loads
window.addEventListener('load', () => {
  syncOneTimePrice();

  // Sync after any click
  document.addEventListener('click', () => {
    setTimeout(syncOneTimePrice, 1000);
  });
});